l
<template>
  <div class="todos-procesos-container">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <div class="icon-container">
            <v-icon color="white" x-large>mdi-application-settings</v-icon>
          </div>
          <div class="title-text">
            <h1 class="main-title">TODOS LOS PROCESOS</h1>
            <p class="subtitle">Gestión completa de procesos de compra</p>
          </div>
        </div>
        <div class="export-section">
          <v-btn
            color="success"
            class="modern-excel-btn"
            rounded
            elevation="4"
            @click="downloadExcel"
          >
            <v-icon left>mdi-file-excel</v-icon>
            EXPORTAR EXCEL
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Dialog observaciones -->
    <v-dialog
      v-model="dialog"
      persistent
      :overlay="false"
      width="90%"
      overlay-color="black"
      overlay-opacity="0.8"
    >
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
            Proceso
          </span>
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->

        <div
          style="width: 95%; margin: 3rem 0rem 0rem 2rem"
          overlay-color="black"
          overlay-opacity="0.8"
        >
          <v-layout wrap>
            <v-flex
              xs9
              sm9
              md9
              style="border-top: 1px solid black; border-left: 1px solid"
            >
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border: solid 1px black; border-right: 0px"
              class="displayCenter fondo"
            >
              <span><strong>Proveedor 1</strong></span>
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border: solid 1px black; border-right: 0px"
              class="displayCenter fondo"
            >
              <span><strong>Proveedor 2</strong></span>
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border: solid 1px black"
              class="displayCenter fondo"
            >
              <span><strong>Proveedor 3</strong></span>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex
              xs2
              sm2
              md2
              style="border: solid 1px black; border-right: 0px"
              class="displayCenter fondo"
            >
              <strong>DESCRIPCION</strong>
            </v-flex>
            <v-flex
              xs3
              sm3
              md3
              style="border: solid 1px black"
              class="displayCenter fondo"
            >
              <strong>DETALLE TÉCNICO</strong>
            </v-flex>
            <v-flex
              xs3
              sm3
              md3
              style="border: solid 1px black; border-right: 0px"
              class="displayCenter fondo"
            >
              <strong>ARGUMENTO PARA LA COMPRA</strong>
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border: solid 1px black"
              class="displayCenter fondo"
            >
              <strong>CANT</strong>
            </v-flex>
            <v-layout wrap>
              <v-flex
                xs4
                sm4
                md4
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span style="font-size: 14px"
                  ><strong>VALOR UNITARIO</strong></span
                >
              </v-flex>
              <v-flex
                xs4
                sm4
                md4
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span style="font-size: 14px"
                  ><strong>VALOR UNITARIO</strong></span
                >
              </v-flex>
              <v-flex
                xs4
                sm4
                md4
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span style="font-size: 14px"
                  ><strong>VALOR UNITARIO</strong></span
                >
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout
            wrap
            v-for="(item, index) in editedItem.infoProceso"
            :key="index"
            style="border: solid 1px black; border-top: 0px"
            overlay-color="black"
            overlay-opacity="0.5"
          >
            <v-flex
              xs2
              sm2
              md2
              style="border-right: solid 1px black"
              class="displayCenter"
            >
              {{ item.concepto }}
            </v-flex>
            <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
              {{ item.expecificaciones }}
            </v-flex>
            <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
              {{ item.observaciones }}
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border-right: solid 1px black"
              class="displayCenter"
            >
              {{ item.cantidad }}
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border-right: solid 1px black"
              class="displayEnd"
            >
              {{
                formatValorUnitario(
                  editedItem.proveedor1.valores[index].valorUnitario,
                )
              }}
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border-right: solid 1px black"
              class="displayEnd"
            >
              {{
                formatValorUnitario(
                  editedItem.proveedor2.valores[index].valorUnitario,
                )
              }}
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="border-right: solid 1px black"
              class="displayEnd"
            >
              {{
                formatValorUnitario(
                  editedItem.proveedor3.valores[index].valorUnitario,
                )
              }}
            </v-flex>
          </v-layout>

          <v-layout
            wrap
            class="d-flex"
            style="border: solid 1px black; border-top: 0px"
            overlay-color="black"
            overlay-opacity="0.5"
          >
            <v-flex> </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="
                border: solid 1px black;
                border-top: 0px;
                border-bottom: 0px;
              "
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="dialog === true"
                  style="border-bottom: solid 1px black"
                >
                  <label for=""
                    ><strong>SUBTOTAL</strong><br />{{
                      formatValorUnitario(editedItem.proveedor1.subTotal)
                    }}</label
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="
                border: solid 1px black;
                border-top: 0px;
                border-bottom: 0px;
              "
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="dialog === true"
                  style="border-bottom: solid 1px black"
                >
                  <label for=""
                    ><strong>SUBTOTAL</strong><br />{{
                      formatValorUnitario(editedItem.proveedor2.subTotal)
                    }}</label
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs1
              sm1
              md1
              style="
                border: solid 1px black;
                border-top: 0px;
                border-bottom: 0px;
                border-right: 0px;
              "
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="dialog === true"
                  style="border-bottom: solid 1px black"
                >
                  <label for=""
                    ><strong>SUBTOTAL</strong><br />{{
                      formatValorUnitario(editedItem.proveedor3.subTotal)
                    }}</label
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex
              xs6
              sm6
              md6
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px"
              class="displayCenter fondo"
              overlay-color="black"
              overlay-opacity="0.5"
            >
              <label for=""><strong>NOMBRE EMPRESA</strong></label>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <label for="">{{
                editedItem.proveedor1
                  ? editedItem.proveedor1.nombreEmpresa
                  : "N/A"
              }}</label>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <label for="">{{
                editedItem.proveedor2
                  ? editedItem.proveedor2.nombreEmpresa
                  : "N/A"
              }}</label>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <label for="">{{
                editedItem.proveedor3
                  ? editedItem.proveedor3.nombreEmpresa
                  : "N/A"
              }}</label>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex
              xs6
              sm6
              md6
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px"
              class="displayCenter fondo"
            >
              <label for=""> <strong>ARGUMENTO PARA LA COMPRA</strong></label>
            </v-flex>
            <v-flex
              xs6
              sm6
              md6
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <label for="">{{ editedItem.observacion }}</label>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex
              xs6
              sm6
              md6
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px"
              class="displayCenter fondo"
            >
              <label for=""> <strong>ARCHIVO ADJUNTO</strong></label>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <v-btn
                v-if="editedItem.proveedor1 && editedItem.proveedor1.ruta_img"
                @click="viewImage(editedItem.proveedor1.ruta_img)"
                outlined
                color="primary"
              >
                Ver Imagen
              </v-btn>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <v-btn
                v-if="editedItem.proveedor2 && editedItem.proveedor2.ruta_img"
                @click="viewImage(editedItem.proveedor2.ruta_img)"
                outlined
                color="primary"
              >
                Ver Imagen
              </v-btn>
            </v-flex>
            <v-flex
              xs2
              sm2
              md2
              v-if="dialog === true"
              style="border: solid 1px black; border-top: 0px; border-left: 0px"
              class="displayCenter"
            >
              <v-btn
                v-if="editedItem.proveedor3 && editedItem.proveedor3.ruta_img"
                @click="viewImage(editedItem.proveedor3.ruta_img)"
                outlined
                color="primary"
              >
                Ver Imagen
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            class="mt-5"
            overlay-color="black"
            overlay-opacity="0.5"
          >
            <v-flex xs3 sm3 md3>
              <v-text-field
                disabled
                label="Maira Londoño"
                class="mr-4"
              ></v-text-field>
              <label for="">ELABORADO POR</label>
              <br />
              Creado:
              <label for="">{{ editedItem.fechaProveedores }}</label>
            </v-flex>
            <v-flex xs6 class="d-flex">
              <v-layout
                wrap
                v-for="(item, index) in editedItem.aprobacion"
                :key="index"
              >
                <v-flex xs12 sm12 md12 v-if="item.rol === 'DIRECTOR AREA'">
                  <v-text-field
                    :value="item.firma"
                    disabled
                    class="mr-4"
                  ></v-text-field>
                  <label for="">APROBACIÓN DIRECTOR DE ÁREA</label>
                  <br />
                  Aprobado:
                  <label for="">{{ item.fechaAprobacion }}</label>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="item.rol === 'CONTROL INTERNO'">
                  <v-text-field disabled :value="item.firma"></v-text-field>
                  <label for="">APROBACIÓN CONTROL INTERNO</label>
                  <br />
                  Aprobado:
                  <label for="">{{ item.fechaAprobacion }}</label>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="item.rol === 'DIRECCION FINANCIERA'"
                >
                  <v-text-field disabled :value="item.firma"></v-text-field>
                  <label for="">APROBACIÓN DIRECCIÓN FINANCIERA</label>
                  <br />
                  Aprobado:
                  <label for="">{{ item.fechaAprobacion }}</label>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="item.rol === 'GERENTE'">
                  <v-text-field disabled :value="item.firma"></v-text-field>
                  <label for="">APROBACIÓN DE LA GERENCIA</label>
                  <br />
                  Aprobado:
                  <label for="">{{ item.fechaAprobacion }}</label>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="2" color="#f7e506" @click="close">cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRechazar" spersistent :overlay="false" width="60%">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-application-cog</v-icon>Rechazar
            Proceso</span
          >
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  v-model="observaciones"
                  label="Argumento para la compra"
                  maxlength="80"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#f7e506" @click="close1">Cancelar</v-btn>
          <v-btn color="#f7e506" @click="rechazarProceso(editedItem)"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para editar proceso completo -->
    <v-dialog
      v-model="dialogEditProceso"
      max-width="900px"
      persistent
      overlay-color="black"
      overlay-opacity="0.8"
    >
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-pencil</v-icon>
            Editar Proceso
          </span>
        </v-card-title>

        <v-card-text overlay-color="black" overlay-opacity="0.8">
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- Proveedor 1 -->
              <v-card
                class="mb-6"
                elevation="8"
                style="border-radius: 16px; background: #ffffff"
              >
                <v-card-title
                  class="white--text pa-6 proveedor1-header"
                  style="
                    background: linear-gradient(
                      135deg,
                      #667eea 0%,
                      #764ba2 100%
                    ) !important;
                    border-radius: 16px 16px 0 0 !important;
                  "
                >
                  <v-icon color="white" class="mr-3" size="28"
                    >mdi-domain</v-icon
                  >
                  <div>
                    <h2
                      class="white--text mb-1"
                      style="font-weight: 600; font-size: 1.5rem"
                    >
                      Proveedor 1
                    </h2>
                    <p
                      class="white--text mb-0"
                      style="opacity: 0.9; font-size: 0.9rem"
                    >
                      {{
                        procesoEditado.proveedor1.nombreEmpresa ||
                        "Información del proveedor"
                      }}
                    </p>
                  </div>
                </v-card-title>

                <v-card-text class="pa-6" style="background: #fafafa">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor1.nit"
                        label="NIT"
                        outlined
                        hint="NIT del proveedor"
                        persistent-hint
                        prepend-inner-icon="mdi-card-account-details"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor1.nombreEmpresa"
                        label="Nombre de la empresa"
                        outlined
                        prepend-inner-icon="mdi-office-building"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor1.contacto"
                        label="Contacto"
                        outlined
                        prepend-inner-icon="mdi-account"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor1.telefono"
                        label="Teléfono"
                        outlined
                        prepend-inner-icon="mdi-phone"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Productos del Proveedor 1 -->
              <v-card
                class="mb-6"
                elevation="6"
                style="
                  border-radius: 12px;
                  background: #ffffff;
                  border-left: 4px solid #667eea;
                  width: 100%;
                "
              >
                <v-card-title class="pa-4" style="background: #f8f9ff">
                  <v-icon color="#667eea" class="mr-3" size="24"
                    >mdi-package-variant</v-icon
                  >
                  <h4
                    class="mb-0"
                    style="color: #667eea; font-weight: 600; font-size: 1.2rem"
                  >
                    Productos y Precios - Proveedor 1
                  </h4>
                </v-card-title>

                <v-card-text class="pa-6">
                  <v-flex
                    xs12
                    v-for="(producto, index) in procesoEditado.infoProceso"
                    :key="'p1-' + index"
                  >
                    <v-card
                      class="mb-4 pa-4"
                      elevation="4"
                      style="
                        border-radius: 16px;
                        background: linear-gradient(
                          135deg,
                          #f8f9ff 0%,
                          #ffffff 100%
                        );
                        border-left: 4px solid #667eea;
                        transition: all 0.3s ease;
                      "
                      @mouseenter="
                        $event.target.style.transform = 'translateY(-2px)'
                      "
                      @mouseleave="
                        $event.target.style.transform = 'translateY(0px)'
                      "
                    >
                      <v-row align="center">
                        <v-col cols="8">
                          <div class="d-flex align-center mb-2">
                            <v-icon color="#667eea" class="mr-2" size="20"
                              >mdi-package-variant-closed</v-icon
                            >
                            <h5
                              class="mb-0"
                              style="
                                color: #2c3e50;
                                font-weight: 600;
                                font-size: 1.1rem;
                              "
                            >
                              {{ producto.concepto }}
                            </h5>
                          </div>
                          <v-chip
                            small
                            color="#667eea"
                            text-color="white"
                            style="font-weight: 500"
                          >
                            <v-icon small left>mdi-scale-balance</v-icon>
                            Cantidad: {{ producto.cantidad }}
                          </v-chip>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            v-model="
                              procesoEditado.proveedor1.valores[index]
                                .valorUnitario
                            "
                            label="Valor Unitario"
                            type="text"
                            outlined
                            dense
                            @input="
                              formatearMoneda($event, 'proveedor1', index)
                            "
                            @blur="calcularSubtotalProveedor1(index)"
                            prepend-inner-icon="mdi-currency-usd"
                            placeholder="0"
                            style="border-radius: 12px"
                            class="elevation-1"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-flex>

                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-card
                        class="pa-4 subtotal-card-proveedor1"
                        elevation="6"
                        style="border-radius: 16px"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="white" class="mr-3" size="24"
                            >mdi-calculator</v-icon
                          >
                          <div>
                            <h6
                              class="mb-1 white--text"
                              style="font-weight: 600"
                            >
                              SubTotal
                            </h6>
                            <h4
                              class="mb-0 white--text"
                              style="font-weight: 700; font-size: 1.5rem"
                            >
                              {{
                                formatCurrency(
                                  procesoEditado.proveedor1.subTotal,
                                )
                              }}
                            </h4>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <!-- Archivo adjunto del Proveedor 1 -->
                    <v-col
                      cols="12"
                      sm="6"
                      overlay-color="black"
                      overlay-opacity="0.5"
                    >
                      <v-card
                        class="pa-4"
                        elevation="4"
                        style="
                          border-radius: 16px;
                          background: linear-gradient(
                            135deg,
                            #f8f9ff 0%,
                            #ffffff 100%
                          );
                          border-left: 4px solid #667eea;
                        "
                      >
                        <div class="d-flex align-center mb-3">
                          <v-icon color="#667eea" class="mr-2" size="24"
                            >mdi-attachment</v-icon
                          >
                          <h6
                            class="mb-0"
                            style="color: #2c3e50; font-weight: 600"
                          >
                            Archivo Adjunto
                          </h6>
                        </div>
                        <div class="d-flex align-center">
                          <v-btn
                            icon
                            color="#667eea"
                            @click="$refs.fileInput1.click()"
                            class="mr-3"
                            style="background: rgba(102, 126, 234, 0.1)"
                          >
                            <v-icon>mdi-camera</v-icon>
                          </v-btn>
                          <span
                            class="font-weight-medium"
                            style="color: #667eea"
                          >
                            Imagen/Archivo Proveedor 1
                          </span>
                        </div>
                        <input
                          ref="fileInput1"
                          type="file"
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                          style="display: none"
                          @change="onArchivoSeleccionado($event, 1)"
                        />
                        <v-btn
                          v-if="procesoEditado.ruta_img1"
                          @click="viewImage(procesoEditado.ruta_img1)"
                          small
                          outlined
                          color="#667eea"
                          class="mt-3"
                          style="border-radius: 12px"
                        >
                          <v-icon small left>mdi-eye</v-icon>
                          Ver Archivo Actual
                        </v-btn>
                        <div v-if="nuevaImagen1" class="mt-3">
                          <v-chip
                            small
                            color="success"
                            style="border-radius: 12px"
                          >
                            <v-icon small left>mdi-check</v-icon>
                            {{ nuevaImagen1.name }}
                          </v-chip>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Proveedor 2 -->
              <v-card
                class="mb-6"
                elevation="8"
                style="border-radius: 16px; background: #ffffff"
              >
                <v-card-title
                  class="white--text pa-6 proveedor2-header"
                  style="
                    background: linear-gradient(
                      135deg,
                      #a78bfa 0%,
                      #8b5cf6 100%
                    ) !important;
                    border-radius: 16px 16px 0 0 !important;
                  "
                >
                  <v-icon color="white" class="mr-3" size="28"
                    >mdi-domain</v-icon
                  >
                  <div>
                    <h2
                      class="white--text mb-1"
                      style="font-weight: 600; font-size: 1.5rem"
                    >
                      Proveedor 2
                    </h2>
                    <p
                      class="white--text mb-0"
                      style="opacity: 0.9; font-size: 0.9rem"
                    >
                      {{
                        procesoEditado.proveedor2.nombreEmpresa ||
                        "Información del proveedor"
                      }}
                    </p>
                  </div>
                </v-card-title>

                <v-card-text class="pa-6" style="background: #fafafa">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor2.nit"
                        label="NIT"
                        outlined
                        hint="NIT del proveedor"
                        persistent-hint
                        prepend-inner-icon="mdi-card-account-details"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor2.nombreEmpresa"
                        label="Nombre de la empresa"
                        outlined
                        prepend-inner-icon="mdi-office-building"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor2.contacto"
                        label="Contacto"
                        outlined
                        prepend-inner-icon="mdi-account"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor2.telefono"
                        label="Teléfono"
                        outlined
                        prepend-inner-icon="mdi-phone"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Productos del Proveedor 2 -->
              <v-card
                class="mb-6"
                elevation="6"
                style="
                  border-radius: 12px;
                  background: #ffffff;
                  border-left: 4px solid #667eea;
                  width: 100%;
                "
              >
                <v-card-title class="pa-4" style="background: #f8f9ff">
                  <v-icon color="#667eea" class="mr-3" size="24"
                    >mdi-package-variant</v-icon
                  >
                  <h4
                    class="mb-0"
                    style="color: #667eea; font-weight: 600; font-size: 1.2rem"
                  >
                    Productos y Precios - Proveedor 2
                  </h4>
                </v-card-title>

                <v-card-text class="pa-6">
                  <v-flex
                    xs12
                    v-for="(producto, index) in procesoEditado.infoProceso"
                    :key="'p2-' + index"
                  >
                    <v-card
                      class="mb-4 pa-4"
                      elevation="4"
                      style="
                        border-radius: 16px;
                        background: linear-gradient(
                          135deg,
                          #f8f9ff 0%,
                          #ffffff 100%
                        );
                        border-left: 4px solid #667eea;
                        transition: all 0.3s ease;
                      "
                      @mouseenter="
                        $event.target.style.transform = 'translateY(-2px)'
                      "
                      @mouseleave="
                        $event.target.style.transform = 'translateY(0px)'
                      "
                    >
                      <v-row align="center">
                        <v-col cols="8">
                          <div class="d-flex align-center mb-2">
                            <v-icon color="#667eea" class="mr-2" size="20"
                              >mdi-package-variant-closed</v-icon
                            >
                            <h5
                              class="mb-0"
                              style="
                                color: #2c3e50;
                                font-weight: 600;
                                font-size: 1.1rem;
                              "
                            >
                              {{ producto.concepto }}
                            </h5>
                          </div>
                          <v-chip
                            small
                            color="#667eea"
                            text-color="white"
                            style="font-weight: 500"
                          >
                            <v-icon small left>mdi-scale-balance</v-icon>
                            Cantidad: {{ producto.cantidad }}
                          </v-chip>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            v-model="
                              procesoEditado.proveedor2.valores[index]
                                .valorUnitario
                            "
                            label="Valor Unitario"
                            type="text"
                            outlined
                            dense
                            @input="
                              formatearMoneda($event, 'proveedor2', index)
                            "
                            @blur="calcularSubtotalProveedor2(index)"
                            prepend-inner-icon="mdi-currency-usd"
                            placeholder="0"
                            style="border-radius: 12px"
                            class="elevation-1"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-flex>

                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-card
                        class="pa-4 subtotal-card-proveedor2"
                        elevation="6"
                        style="border-radius: 16px"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="white" class="mr-3" size="24"
                            >mdi-calculator</v-icon
                          >
                          <div>
                            <h6
                              class="mb-1 white--text"
                              style="font-weight: 600"
                            >
                              SubTotal
                            </h6>
                            <h4
                              class="mb-0 white--text"
                              style="font-weight: 700; font-size: 1.5rem"
                            >
                              {{
                                formatCurrency(
                                  procesoEditado.proveedor2.subTotal,
                                )
                              }}
                            </h4>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <!-- Archivo adjunto del Proveedor 2 -->
                    <v-col
                      cols="12"
                      sm="6"
                      overlay-color="black"
                      overlay-opacity="0.5"
                    >
                      <v-card
                        class="pa-4"
                        elevation="4"
                        style="
                          border-radius: 16px;
                          background: linear-gradient(
                            135deg,
                            #f8f9ff 0%,
                            #ffffff 100%
                          );
                          border-left: 4px solid #667eea;
                        "
                      >
                        <div class="d-flex align-center mb-3">
                          <v-icon color="#667eea" class="mr-2" size="24"
                            >mdi-attachment</v-icon
                          >
                          <h6
                            class="mb-0"
                            style="color: #2c3e50; font-weight: 600"
                          >
                            Archivo Adjunto
                          </h6>
                        </div>
                        <div class="d-flex align-center">
                          <v-btn
                            icon
                            color="#667eea"
                            @click="$refs.fileInput2.click()"
                            class="mr-3"
                            style="background: rgba(102, 126, 234, 0.1)"
                          >
                            <v-icon>mdi-camera</v-icon>
                          </v-btn>
                          <span
                            class="font-weight-medium"
                            style="color: #667eea"
                          >
                            Imagen/Archivo Proveedor 2
                          </span>
                        </div>
                        <input
                          ref="fileInput2"
                          type="file"
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                          style="display: none"
                          @change="onArchivoSeleccionado($event, 2)"
                        />
                        <v-btn
                          v-if="procesoEditado.ruta_img2"
                          @click="viewImage(procesoEditado.ruta_img2)"
                          small
                          outlined
                          color="#667eea"
                          class="mt-3"
                          style="border-radius: 12px"
                        >
                          <v-icon small left>mdi-eye</v-icon>
                          Ver Archivo Actual
                        </v-btn>
                        <div v-if="nuevaImagen2" class="mt-3">
                          <v-chip
                            small
                            color="success"
                            style="border-radius: 12px"
                          >
                            <v-icon small left>mdi-check</v-icon>
                            {{ nuevaImagen2.name }}
                          </v-chip>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Proveedor 3 -->
              <v-card
                class="mb-6"
                elevation="8"
                style="border-radius: 16px; background: #ffffff"
              >
                <v-card-title
                  class="white--text pa-6 proveedor3-header"
                  style="
                    background: linear-gradient(
                      135deg,
                      #4facfe 0%,
                      #00f2fe 100%
                    ) !important;
                    border-radius: 16px 16px 0 0 !important;
                  "
                >
                  <v-icon color="white" class="mr-3" size="28"
                    >mdi-domain</v-icon
                  >
                  <div>
                    <h2
                      class="white--text mb-1"
                      style="font-weight: 600; font-size: 1.5rem"
                    >
                      Proveedor 3
                    </h2>
                    <p
                      class="white--text mb-0"
                      style="opacity: 0.9; font-size: 0.9rem"
                    >
                      {{
                        procesoEditado.proveedor3.nombreEmpresa ||
                        "Información del proveedor"
                      }}
                    </p>
                  </div>
                </v-card-title>

                <v-card-text class="pa-6" style="background: #fafafa">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor3.nit"
                        label="NIT"
                        outlined
                        hint="NIT del proveedor"
                        persistent-hint
                        prepend-inner-icon="mdi-card-account-details"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor3.nombreEmpresa"
                        label="Nombre de la empresa"
                        outlined
                        prepend-inner-icon="mdi-office-building"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor3.contacto"
                        label="Contacto"
                        outlined
                        prepend-inner-icon="mdi-account"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="procesoEditado.proveedor3.telefono"
                        label="Teléfono"
                        outlined
                        prepend-inner-icon="mdi-phone"
                        style="border-radius: 12px"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Productos del Proveedor 3 -->
              <v-card
                class="mb-6"
                elevation="6"
                style="
                  border-radius: 12px;
                  background: #ffffff;
                  border-left: 4px solid #667eea;
                  width: 100%;
                "
              >
                <v-card-title class="pa-4" style="background: #f8f9ff">
                  <v-icon color="#667eea" class="mr-3" size="24"
                    >mdi-package-variant</v-icon
                  >
                  <h4
                    class="mb-0"
                    style="color: #667eea; font-weight: 600; font-size: 1.2rem"
                  >
                    Productos y Precios - Proveedor 3
                  </h4>
                </v-card-title>

                <v-card-text class="pa-6">
                  <v-flex
                    xs12
                    v-for="(producto, index) in procesoEditado.infoProceso"
                    :key="'p3-' + index"
                  >
                    <v-card
                      class="mb-4 pa-4"
                      elevation="4"
                      style="
                        border-radius: 16px;
                        background: linear-gradient(
                          135deg,
                          #f8f9ff 0%,
                          #ffffff 100%
                        );
                        border-left: 4px solid #667eea;
                        transition: all 0.3s ease;
                      "
                      @mouseenter="
                        $event.target.style.transform = 'translateY(-2px)'
                      "
                      @mouseleave="
                        $event.target.style.transform = 'translateY(0px)'
                      "
                    >
                      <v-row align="center">
                        <v-col cols="8">
                          <div class="d-flex align-center mb-2">
                            <v-icon color="#667eea" class="mr-2" size="20"
                              >mdi-package-variant-closed</v-icon
                            >
                            <h5
                              class="mb-0"
                              style="
                                color: #2c3e50;
                                font-weight: 600;
                                font-size: 1.1rem;
                              "
                            >
                              {{ producto.concepto }}
                            </h5>
                          </div>
                          <v-chip
                            small
                            color="#667eea"
                            text-color="white"
                            style="font-weight: 500"
                          >
                            <v-icon small left>mdi-scale-balance</v-icon>
                            Cantidad: {{ producto.cantidad }}
                          </v-chip>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            v-model="
                              procesoEditado.proveedor3.valores[index]
                                .valorUnitario
                            "
                            label="Valor Unitario"
                            type="text"
                            outlined
                            dense
                            @input="
                              formatearMoneda($event, 'proveedor3', index)
                            "
                            @blur="calcularSubtotalProveedor3(index)"
                            prepend-inner-icon="mdi-currency-usd"
                            placeholder="0"
                            style="border-radius: 12px"
                            class="elevation-1"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-flex>

                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-card
                        class="pa-4 subtotal-card-proveedor3"
                        elevation="6"
                        style="border-radius: 16px"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="white" class="mr-3" size="24"
                            >mdi-calculator</v-icon
                          >
                          <div>
                            <h6
                              class="mb-1 white--text"
                              style="font-weight: 600"
                            >
                              SubTotal
                            </h6>
                            <h4
                              class="mb-0 white--text"
                              style="font-weight: 700; font-size: 1.5rem"
                            >
                              {{
                                formatCurrency(
                                  procesoEditado.proveedor3.subTotal,
                                )
                              }}
                            </h4>
                          </div>
                        </div>
                      </v-card>
                    </v-col>

                    <!-- Archivo adjunto del Proveedor 3 -->
                    <v-col
                      cols="12"
                      sm="6"
                      overlay-color="black"
                      overlay-opacity="0.5"
                    >
                      <v-card
                        class="pa-4"
                        elevation="4"
                        style="
                          border-radius: 16px;
                          background: linear-gradient(
                            135deg,
                            #f8f9ff 0%,
                            #ffffff 100%
                          );
                          border-left: 4px solid #667eea;
                        "
                      >
                        <div class="d-flex align-center mb-3">
                          <v-icon color="#667eea" class="mr-2" size="24"
                            >mdi-attachment</v-icon
                          >
                          <h6
                            class="mb-0"
                            style="color: #2c3e50; font-weight: 600"
                          >
                            Archivo Adjunto
                          </h6>
                        </div>
                        <div class="d-flex align-center">
                          <v-btn
                            icon
                            color="#667eea"
                            @click="$refs.fileInput3.click()"
                            class="mr-3"
                            style="background: rgba(102, 126, 234, 0.1)"
                          >
                            <v-icon>mdi-camera</v-icon>
                          </v-btn>
                          <span
                            class="font-weight-medium"
                            style="color: #667eea"
                          >
                            Imagen/Archivo Proveedor 3
                          </span>
                        </div>
                        <input
                          ref="fileInput3"
                          type="file"
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                          style="display: none"
                          @change="onArchivoSeleccionado($event, 3)"
                        />
                        <v-btn
                          v-if="procesoEditado.ruta_img3"
                          @click="viewImage(procesoEditado.ruta_img3)"
                          small
                          outlined
                          color="#667eea"
                          class="mt-3"
                          style="border-radius: 12px"
                        >
                          <v-icon small left>mdi-eye</v-icon>
                          Ver Archivo Actual
                        </v-btn>
                        <div v-if="nuevaImagen3" class="mt-3">
                          <v-chip
                            small
                            color="success"
                            style="border-radius: 12px"
                          >
                            <v-icon small left>mdi-check</v-icon>
                            {{ nuevaImagen3.name }}
                          </v-chip>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#f7e506" @click="cerrarEditarProceso">Cancelar</v-btn>
          <v-btn
            color="#f7e506"
            @click="guardarCambiosProceso"
            :loading="loadingUpdate"
          >
            <span v-if="!loadingUpdate">Guardar Cambios</span>
            <span v-else>
              {{
                nuevaImagen1 || nuevaImagen2 || nuevaImagen3
                  ? "Subiendo archivos..."
                  : "Guardando..."
              }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="contenedor" class="mt-8">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-dialog
            v-model="dialogEdit"
            max-width="700px"
            persistent
            overlay-color="black"
            overlay-opacity="0.5"
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-account</v-icon> Editar
                  Proveedor</span
                >
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout
                    wrap
                    v-for="(
                      valoresProveedor, proveedorIndex
                    ) in editedItem.infoProceso"
                    :key="proveedorIndex"
                  >
                    <v-flex xs12>
                      <h2 class="title_h2">Proveedor 1</h2>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="editedItem.proveedor1.nombreEmpresa"
                        label="Nombre de la empresa "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="editedItem.proveedor1.contacto"
                        label="Contacto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor1.direccion"
                        label="Direccion"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor1.ciudad"
                        label="Ciudad"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor1 &&
                        editedItem.proveedor1.valores &&
                        editedItem.proveedor1.valores.subtotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor1.valores.subtotal"
                        label="Valor Unitario"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor1.subTotal"
                        label="SubTotal"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor1 &&
                        editedItem.proveedor1.valores &&
                        editedItem.proveedor1.valores.iva !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor1.valores.iva"
                        label="Iva"
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor1 &&
                        editedItem.proveedor1.valores &&
                        editedItem.proveedor1.valores.valorTotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor1.valores.valorTotal"
                        label="Valor Total"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      :class="{
                        'xs12 sm6 md6':
                          editedItem.proveedor1 &&
                          editedItem.proveedor1.valores &&
                          editedItem.proveedor1.valores.valorTotal !==
                            undefined,
                        'xs12 sm6 md6': !(
                          editedItem.proveedor1 &&
                          editedItem.proveedor1.valores &&
                          editedItem.proveedor1.valores.valorTotal !== undefined
                        ),
                      }"
                    >
                      <v-text-field
                        v-model="editedItem.proveedor1.total"
                        label="Total"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <h2 class="title_h2">Proveedor 2</h2>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor2.nombreEmpresa"
                        label="Nombre de la empresa"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor2.contacto"
                        label="Contacto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor2.direccion"
                        label="Direccion"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor2.ciudad"
                        label="Ciudad"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs6
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor2 &&
                        editedItem.proveedor2.valores &&
                        editedItem.proveedor2.valores.subtotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor2.valores.subtotal"
                        label="Valor Unitario"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor2.subTotal"
                        label="SubTotal"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs6
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor2 &&
                        editedItem.proveedor2.valores &&
                        editedItem.proveedor2.valores.iva !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor2.valores.iva"
                        label="Iva"
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      xs6
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor2 &&
                        editedItem.proveedor2.valores &&
                        editedItem.proveedor2.valores.valorTotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor2.valores.valorTotal"
                        label="Valor Total"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      :class="{
                        'xs6 sm6 md6':
                          editedItem.proveedor2 &&
                          editedItem.proveedor2.valores &&
                          editedItem.proveedor2.valores.valorTotal !==
                            undefined,
                        'xs6 sm6 md6': !(
                          editedItem.proveedor2 &&
                          editedItem.proveedor2.valores &&
                          editedItem.proveedor2.valores.valorTotal !== undefined
                        ),
                      }"
                    >
                      <v-text-field
                        v-model="editedItem.proveedor2.total"
                        label="Total"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <h2 class="title_h2">Proveedor 3</h2>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor3.nombreEmpresa"
                        label="Nombre de la empresa"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor3.contacto"
                        label="Contacto"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor3.direccion"
                        label="Direccion"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor3.ciudad"
                        label="Ciudad"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor3 &&
                        editedItem.proveedor3.valores &&
                        editedItem.proveedor3.valores.subtotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor3.valores.subtotal"
                        label="Valor Unitario"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="editedItem.proveedor3.subTotal"
                        label="SubTotal"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor3 &&
                        editedItem.proveedor3.valores &&
                        editedItem.proveedor3.valores.iva !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor3.valores.iva"
                        label="Iva"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6
                      v-if="
                        editedItem.proveedor3 &&
                        editedItem.proveedor3.valores &&
                        editedItem.proveedor3.valores.valorTotal !== undefined
                      "
                    >
                      <v-text-field
                        v-model="editedItem.proveedor3.valores.valorTotal"
                        label="Valor Total"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      :class="{
                        'xs6 sm6 md6':
                          editedItem.proveedor3 &&
                          editedItem.proveedor3.valores &&
                          editedItem.proveedor3.valores.valorTotal !==
                            undefined,
                        'xs6 sm6 md6': !(
                          editedItem.proveedor3 &&
                          editedItem.proveedor3.valores &&
                          editedItem.proveedor3.valores.valorTotal !== undefined
                        ),
                      }"
                    >
                      <v-text-field
                        v-model="editedItem.proveedor3.total"
                        label="Total"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#f7e506" @click="cerrarEditarProceso"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="#f7e506"
                  @click="guardarCambiosProceso"
                  :loading="loadingUpdate"
                >
                  <span v-if="!loadingUpdate">Guardar Cambios</span>
                  <span v-else>
                    {{
                      nuevaImagen1 || nuevaImagen2 || nuevaImagen3
                        ? "Subiendo archivos..."
                        : "Guardando..."
                    }}
                  </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </div>

    <br />

    <!-- Filters Section -->
    <div class="filters-row">
      <div class="filter-date-left">
        <v-text-field
          v-model="fechaInicio"
          label="Fecha inicio"
          type="date"
          class="modern-date-field"
          outlined
          rounded
          hide-details
          @input="aplicarFiltroFechas"
          @change="aplicarFiltroFechas"
          prepend-inner-icon="mdi-calendar"
        ></v-text-field>
      </div>
      <div class="filter-search-center">
        <v-text-field
          v-model="search"
          label="Buscar procesos"
          class="modern-search-field"
          outlined
          rounded
          hide-details
          prepend-inner-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </div>
      <div class="filter-date-right">
        <v-text-field
          v-model="fechaFin"
          label="Fecha fin"
          type="date"
          class="modern-date-field"
          outlined
          rounded
          hide-details
          @input="aplicarFiltroFechas"
          @change="aplicarFiltroFechas"
          prepend-inner-icon="mdi-calendar"
        ></v-text-field>
      </div>
      <v-row>
        <v-col
          cols="12"
          md="2"
          class="d-flex flex-column align-center justify-center"
        >
          <div class="filter-controls-container">
            <v-btn
              v-if="filtroActivo"
              @click="limpiarFiltroFechas"
              color="red lighten-2"
              rounded
              class="modern-clear-btn mb-2"
              outlined
              block
            >
              <v-icon left small>mdi-close-circle</v-icon>
              Limpiar
            </v-btn>
            <v-chip
              v-if="filtroActivo"
              color="primary"
              text-color="white"
              class="modern-registros-chip"
              rounded
            >
              {{ procesosFiltrados.length }} registros
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Table Section -->
    <div class="table-section">
      <div class="modern-table">
        <v-data-table
          :headers="headers"
          :items="procesos"
          :search="search"
          class="modern-data-table"
        >
          <template v-slot:no-data>
            <v-alert
              :value="true"
              color="#F44336"
              icon="mdi-alert"
              outlined
              type="warning"
              prominent
              border="left"
            >
              <strong>No</strong> se encontro su busqueda
            </v-alert>
          </template>

          <template v-slot:[`item.pdfGeneral`]="{ item }">
            <v-icon
              v-if="item.estado !== '3'"
              class="mr-2"
              @click="modalPdf(item)"
              color="red"
              >mdi-file-pdf-box</v-icon
            >
          </template>
          <!-- Template para hacer editable la columna Fecha Entrega -->
          <template v-slot:[`item.fechaEntrega`]="{ item }">
            <v-menu
              v-model="item.menuFecha"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :disabled="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="
                    item.fechaEntregaFormatted
                      ? formatFechaDDMM(item.fechaEntregaFormatted)
                      : ''
                  "
                  dense
                  hide-details
                  readonly
                  v-on="on"
                  v-bind="attrs"
                  @click="abrirSelectorFecha(item)"
                  @focus="abrirSelectorFecha(item)"
                  class="fecha-entrega-field custom-date-field"
                  placeholder="dd/mm/aaaa"
                  prepend-inner-icon="mdi-calendar"
                  color="primary"
                  :style="{
                    'min-width': '120px',
                    'max-width': '140px',
                    'font-size': '12px',
                  }"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.fechaEntregaFormatted"
                @change="
                  (date) => {
                    if (date) {
                      item.fechaEntrega = date;
                      item.fechaEntregaFormatted = date;
                      actualizarFechaEntrega(item);
                    }
                  }
                "
                locale="es"
                color="primary"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </template>
          <template v-slot:[`item.estado`]="{ item }">
            <div v-if="item.estado === '0'" data-estado="0">
              <v-chip outlined class="ma-2" color="red"> CANCELADO </v-chip>
            </div>
            <div v-if="item.estado === '1'" data-estado="1">
              <v-chip outlined class="ma-2" color="orange darken-2">
                GERENTE
              </v-chip>
            </div>
            <div v-if="item.estado === '2'" data-estado="2">
              <v-chip outlined class="ma-2" color="red"> RECHAZADO </v-chip>
            </div>
            <div v-if="item.estado === '3'" data-estado="3">
              <v-chip outlined class="ma-2" color="amber accent-4">
                COMPRAS
              </v-chip>
            </div>
            <div v-if="item.estado === '5'" data-estado="5">
              <v-chip outlined class="ma-2" color="green darken-4">
                DIRECCION FINANCIERA
              </v-chip>
            </div>
            <div v-if="item.estado === '4'" data-estado="4">
              <v-chip outlined class="ma-2" color="green">
                APROBACION DIRECTOR AREA
              </v-chip>
            </div>
            <div v-if="item.estado === '6'" data-estado="6">
              <v-chip outlined class="ma-2" color="green">
                APROBACION GERENTE
              </v-chip>
            </div>
            <div v-if="item.estado === '7'" data-estado="7">
              <v-chip outlined class="ma-2" color="green">
                REALIZAR COMPRA
              </v-chip>
            </div>
            <div v-if="item.estado === '8'" data-estado="8">
              <v-chip outlined class="ma-2" color="green">
                COMPRA REALIZADA
              </v-chip>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div style="display: flex; align-items: center">
              <v-icon
                medium
                v-if="item.ruta_img && item.ruta_img !== ''"
                color="green"
                @click="verArchivos(item)"
                style="cursor: pointer"
                >mdi-eye
              </v-icon>
              <v-icon
                v-if="item.estado !== '8'"
                class="mr-2"
                color="error"
                @click="eliminarCompra(item)"
              >
                mdi-delete
              </v-icon>
              <v-icon
                v-if="['3', '4'].includes(item.estado)"
                class="mr-2"
                color="orange"
                @click="editarProceso(item)"
              >
                mdi-account-edit
              </v-icon>
              <v-icon
                v-if="item.estado == 2"
                color="primary"
                medium
                class="mr-2"
                @click="habilitar(item)"
              >
                mdi-repeat
              </v-icon>
              <v-icon
                v-if="['6', '7', '8'].includes(item.estado)"
                class="mr-2"
                color="blue"
                style="cursor: pointer"
                @click="abrirDialogDescarga(item)"
              >
                mdi-download
              </v-icon>

              <!-- Dialog para descargar PDF, solo una vez y con hide-overlay -->
              <v-dialog
                :key="dialogDescargaKey"
                v-model="dialogDescarga"
                max-width="600px"
                @input="if (!dialogDescarga) cerrarDialogDescarga();"
                persistent
                overlay-color="black"
                overlay-opacity="0.1"
              >
                <v-card
                  flat
                  elevation="0"
                  class="pa-4 descarga-pdf-card"
                  style="
                    background: #fff;
                    box-shadow: none !important;
                    border-radius: 10px;
                    border: 1px solid #e0e0e0;
                  "
                >
                  <v-card-title
                    class="headline d-flex align-center"
                    style="color: #3f51b5; font-weight: 700"
                  >
                    <v-icon color="primary" left class="mr-2"
                      >mdi-file-pdf-box</v-icon
                    >
                    Descargar PDF
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      @click="cerrarDialogDescarga()"
                      aria-label="Cerrar"
                    >
                      <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider class="mb-4"></v-divider>
                  <v-card-text>
                    <!-- Selección de proveedor -->
                    <div class="mb-4">
                      <h4 class="mb-2">Seleccionar Proveedor:</h4>
                      <v-radio-group
                        v-model="proveedorSeleccionado"
                        row
                        @change="actualizarCamposPorProveedor"
                      >
                        <v-radio
                          :label="
                            itemDescarga &&
                            itemDescarga.proveedor1 &&
                            itemDescarga.proveedor1.nombreEmpresa
                              ? 'Proveedor 1 (' +
                                itemDescarga.proveedor1.nombreEmpresa +
                                ')'
                              : 'Proveedor 1 (Sin datos)'
                          "
                          :value="
                            getProveedorValue(
                              itemDescarga && itemDescarga.proveedor1,
                              1,
                            )
                          "
                          color="green darken-2"
                          class="mb-2 proveedor-radio-item"
                          :class="{
                            'proveedor-seleccionado':
                              proveedorSeleccionado == 1 ||
                              proveedorSeleccionado === '1',
                          }"
                          :disabled="
                            !itemDescarga ||
                            !itemDescarga.proveedor1 ||
                            !itemDescarga.proveedor1.nombreEmpresa
                          "
                        ></v-radio>
                        <v-radio
                          :label="
                            itemDescarga &&
                            itemDescarga.proveedor2 &&
                            itemDescarga.proveedor2.nombreEmpresa
                              ? 'Proveedor 2 (' +
                                itemDescarga.proveedor2.nombreEmpresa +
                                ')'
                              : 'Proveedor 2 (Sin datos)'
                          "
                          :value="
                            getProveedorValue(
                              itemDescarga && itemDescarga.proveedor2,
                              2,
                            )
                          "
                          color="blue darken-2"
                          class="mb-2 proveedor-radio-item"
                          :class="{
                            'proveedor-seleccionado':
                              proveedorSeleccionado == 2 ||
                              proveedorSeleccionado === '2',
                          }"
                          :disabled="
                            !itemDescarga ||
                            !itemDescarga.proveedor2 ||
                            !itemDescarga.proveedor2.nombreEmpresa
                          "
                        ></v-radio>
                        <v-radio
                          :label="
                            itemDescarga &&
                            itemDescarga.proveedor3 &&
                            itemDescarga.proveedor3.nombreEmpresa
                              ? 'Proveedor 3 (' +
                                itemDescarga.proveedor3.nombreEmpresa +
                                ')'
                              : 'Proveedor 3 (Sin datos)'
                          "
                          :value="
                            getProveedorValue(
                              itemDescarga && itemDescarga.proveedor3,
                              3,
                            )
                          "
                          color="amber darken-2"
                          class="mb-2 proveedor-radio-item"
                          :class="{
                            'proveedor-seleccionado':
                              proveedorSeleccionado == 3 ||
                              proveedorSeleccionado === '3',
                          }"
                          :disabled="
                            !itemDescarga ||
                            !itemDescarga.proveedor3 ||
                            !itemDescarga.proveedor3.nombreEmpresa
                          "
                        ></v-radio>
                      </v-radio-group>

                      <!-- Mensaje cuando no hay proveedores disponibles -->
                      <v-alert
                        v-if="!hayProveedoresDisponibles"
                        type="warning"
                        class="mt-2"
                        dense
                      >
                        No hay proveedores registrados para este proceso
                      </v-alert>

                      <!-- Vista previa del proveedor seleccionado -->
                      <div
                        v-if="proveedorPreview"
                        class="mt-4"
                        style="
                          border: 1px dashed #cfcfcf;
                          padding: 12px;
                          border-radius: 6px;
                        "
                      >
                        <h5 class="mb-2">
                          Vista previa del proveedor seleccionado
                        </h5>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <strong>Empresa:</strong>
                            <div>
                              {{
                                proveedorPreview.nombreEmpresa ||
                                "No disponible"
                              }}
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <strong>NIT:</strong>
                            <div>
                              {{
                                proveedorPreview.nit ||
                                proveedorPreview.NIT ||
                                "No disponible"
                              }}
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <strong>Contacto:</strong>
                            <div>
                              {{
                                proveedorPreview.contacto ||
                                proveedorPreview.Contacto ||
                                "No disponible"
                              }}
                            </div>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <strong>Teléfono / Celular:</strong>
                            <div>
                              {{
                                proveedorPreview.telefono ||
                                proveedorPreview.celular ||
                                "No disponible"
                              }}
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <strong>Dirección / Ciudad:</strong>
                            <div>
                              {{ proveedorPreview.direccion || "" }}
                              {{
                                proveedorPreview.ciudad
                                  ? " - " + proveedorPreview.ciudad
                                  : ""
                              }}
                            </div>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <strong>Observaciones:</strong>
                            <div>
                              {{
                                proveedorPreview.observaciones ||
                                proveedorPreview.Observaciones ||
                                "N/A"
                              }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <!-- Campo O.C # -->
                    <v-text-field
                      v-model="ocNumero"
                      label="O.C #"
                      type="text"
                      class="mt-2"
                      outlined
                      prepend-inner-icon="mdi-pound"
                    ></v-text-field>

                    <!-- Campo Fecha General - editable manualmente -->
                    <v-menu
                      ref="menuFechaGeneral"
                      v-model="menuFechaGeneral"
                      :close-on-content-click="false"
                      :close-on-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      @click:outside="menuFechaGeneral = false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fechaGeneralMostrar"
                          label="Fecha General"
                          type="text"
                          class="mt-2"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          placeholder="YYYY-MM-DD o hacer clic en el calendario"
                          hint="Esta fecha aparecerá en el campo FECHA del PDF. Puedes escribirla manualmente (YYYY-MM-DD) o usar el calendario"
                          persistent-hint
                          @input="actualizarFechaGeneralEnTiempoReal"
                          @blur="normalizarFechaGeneral"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaGeneralValida"
                        @click:date="actualizarFechaGeneralDesdeCalendario"
                        locale="es"
                        color="primary"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>

                    <!-- Campo para editar Concepto -->
                    <div
                      v-for="(articulo, index) in conceptosEditados"
                      :key="'concepto-' + index"
                      class="mb-3"
                    >
                      <v-text-field
                        v-model="articulo.concepto"
                        :label="`Artículo ${index + 1} - ${
                          articulo.cantidad
                        } unidad(es)`"
                        type="text"
                        outlined
                        prepend-inner-icon="mdi-text"
                        :hint="`Este texto aparecerá en la fila ${
                          index + 1
                        } del PDF en ARTICULO/DESCRIPCION`"
                        persistent-hint
                      ></v-text-field>
                    </div>
                    <!-- ✅ Mensaje si no hay artículos -->
                    <v-alert
                      v-if="conceptosEditados.length === 0"
                      type="info"
                      text
                      class="mt-2"
                    >
                      No hay artículos para editar en este proceso
                    </v-alert>

                    <!-- Botón para Cambiar Cantidad y Sección Desplegable -->
                    <div v-if="conceptosEditados && conceptosEditados.length > 0" class="mb-3">
                      <v-btn
                        small
                        outlined
                        color="primary"
                        class="text-none font-weight-bold"
                        style="border-radius: 8px;"
                        @click="mostrarEdicionCantidad = !mostrarEdicionCantidad"
                      >
                        <v-icon left small>mdi-pencil</v-icon>
                        {{ mostrarEdicionCantidad ? 'OCULTAR CANTIDADES' : 'CAMBIAR CANTIDAD' }}
                      </v-btn>

                      <!-- Sección colapsable que se muestra solo al pulsar CAMBIAR CANTIDAD -->
                      <v-expand-transition>
                        <div
                          v-if="mostrarEdicionCantidad"
                          class="mt-3 pa-3"
                          style="
                            background: #f9fbfd;
                            border: 1px dashed #3f51b5;
                            border-radius: 8px;
                          "
                        >
                          <div class="subtitle-2 font-weight-bold mb-2 primary--text d-flex align-center">
                            <v-icon small color="primary" class="mr-1">mdi-package-variant</v-icon>
                            Modificar cantidades
                          </div>

                          <div
                            v-for="(itemCantidad, idx) in conceptosEditados"
                            :key="'qty-edit-' + idx"
                            class="mb-3"
                          >
                            <div class="caption font-weight-medium text-truncate mb-1" style="color: #333;">
                              {{ itemCantidad.concepto || `Artículo ${idx + 1}` }}
                            </div>
                            <v-text-field
                              v-model.number="itemCantidad.cantidad"
                              type="number"
                              min="1"
                              step="1"
                              label="Cantidad"
                              outlined
                              dense
                              hide-details
                              prepend-inner-icon="mdi-counter"
                              style="background: #fff; max-width: 180px;"
                              :error="!itemCantidad.cantidad || Number(itemCantidad.cantidad) <= 0"
                            ></v-text-field>
                          </div>

                          <div class="caption mt-2" style="color: #666; font-style: italic;">
                            <v-icon x-small color="grey" class="mr-1">mdi-information-outline</v-icon>
                            La cantidad modificada se guardará y aparecerá en futuros documentos.
                          </div>
                        </div>
                      </v-expand-transition>
                    </div>

                    <!-- Campo de fecha - solo calendario -->
                    <v-menu
                      ref="menuFechaDescarga"
                      v-model="menuFechaDescarga"
                      :close-on-content-click="false"
                      :close-on-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      @click:outside="menuFechaDescarga = false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="fechaEntregaDescarga"
                          label="Fecha de entrega"
                          type="text"
                          class="mt-2"
                          outlined
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          placeholder="Hacer clic en el calendario para seleccionar"
                          hint="Usa el calendario para seleccionar la fecha"
                          persistent-hint
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaEntregaDescarga"
                        @click:date="menuFechaDescarga = false"
                        locale="es"
                        color="primary"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="primary"
                      :disabled="
                        !proveedorSeleccionado ||
                        !fechaEntregaDescarga ||
                        !ocNumero ||
                        !conceptosEditados ||
                        conceptosEditados.length === 0 ||
                        !fechaGeneral
                      "
                      @click="descargarPDFSeleccionado"
                      class="white--text"
                    >
                      <v-icon left>mdi-download</v-icon> Descargar
                    </v-btn>
                    <v-btn
                      v-if="itemDescarga && itemDescarga.estado === '7'"
                      color="green"
                      :disabled="!fechaEntregaDescarga"
                      @click="realizarCompraDesdeModal"
                      class="white--text ml-2"
                    >
                      <v-icon left>mdi-cart</v-icon> Realizar Compra
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title>Fecha de Entrega</v-card-title>
        <v-card-text>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaEntrega"
                type="date"
                label="Seleccionar fecha"
                readonly
                v-on="on"
                @change="fechaEntregaError = false"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaEntrega"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="realizarCompra(item)"
            outlined
            color="green"
            :disabled="isLoading"
          >
            REALIZAR COMPRA
            <v-progress-circular
              v-if="isLoading"
              indeterminate
              color="blue"
              size="20"
              class="ml-2"
            ></v-progress-circular>
          </v-btn>
          <v-btn color="red" outlined @click="cancelar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- alertas de las acciones que se hacen -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#601ae4"
      style="color: white"
      overlay-color="black"
      overlay-opacity="0.8"
    >
      {{ text }}
      <v-btn color="#601ae4" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="dialogArchivos"
      max-width="900px"
      persistent
      overlay-color="black"
      overlay-opacity="0.8"
    >
      <v-card>
        <v-card-title class="headline">Archivos Adjuntos</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="(archivo, idx) in archivosModal"
              :key="idx"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-flex flex-column align-center"
            >
              <div
                class="archivo-preview-modal-director"
                @click="abrirArchivo(archivo)"
              >
                <template v-if="esImagen(archivo)">
                  <v-img :src="archivo" contain height="100%" width="100%" />
                </template>
                <template v-else>
                  <v-icon color="primary" size="60">mdi-file-document</v-icon>
                </template>
              </div>
              <div class="archivo-nombre-modal-director">
                {{ nombreArchivo(archivo) }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogArchivos = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de carga global -->
    <v-dialog
      v-model="showLoadingModal"
      persistent
      max-width="300px"
      overlay-opacity="0.8"
    >
      <v-card class="pa-6" style="text-align: center">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="7"
        ></v-progress-circular>
        <h3 class="mt-4">Procesando compra...</h3>
        <p class="mt-2">Por favor espere</p>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import Vue from "vue";
import swal from "sweetalert";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

export default {
  data() {
    return {
      dialogEdit: false,
      dialogEditProceso: false,
      loadingUpdate: false,
      dialogArchivos: false,
      archivosModal: [],
      conceptosEditados: [], // Campo para editar el concepto
      mostrarEdicionCantidad: false, // Controla el despliegue de modificar cantidades
      procesosEliminados: [],
      procesoEditado: {
        proveedor1: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
        proveedor2: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
        proveedor3: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
      },
      nuevaImagen1: null,
      nuevaImagen2: null,
      nuevaImagen3: null,
      show: false,
      isLoading: false,
      menu: false,
      fechaEntrega: null,
      fechaEntregaError: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      procesos: [],
      infoProcesos: [],
      valoresProveedores: [],
      dialog: false,
      dialogRechazar: false,
      observaciones: "",
      updateSuppliers: [],
      loading: false,
      loading3: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      headers: [
        {
          text: "ID",
          value: "idProceso_procesos",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "EMPRESA",
          value: "empresa",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "CONCEPTO",
          value: "infoConcepto",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "DIRECTOR",
          value: "nombre",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "CREACION",
          value: "fechaCreacion",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "GENERAL",
          value: "pdfGeneral",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ESTADO",
          value: "estado",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "FECHA ENTREGA",
          value: "fechaEntrega",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ACCIONES",
          value: "actions",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      defaultItem: {
        id: "",
        concepto: "",
        cantidad: "",
        especificacion: "",
        observaciones: "",
        aprobacion: "",
        proveedor1: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        proveedor2: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        proveedor3: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        infoProceso: [],
        aprobacion: [],
      },
      editedIndex: -1,
      editedItem: {
        proveedor1: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        proveedor2: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        proveedor3: {
          nombreEmpresa: "",
          contacto: "",
          direccion: "",
          ciudad: "",
          subTotal: 0,
          total: 0,
          valores: {
            subtotal: 0,
            valorTotal: 0,
            iva: 0,
          },
        },
        infoProceso: [],
        aprobacion: [],
      },
      dialogDescarga: false,
      dialogDescargaKey: 0,
      itemDescarga: null,
      proveedorSeleccionado: null,
      fechaEntregaDescarga: "",
      menuFechaDescarga: false, // Para el selector de fecha en el modal de descarga
      fechaGeneral: "", // Campo para la fecha general del PDF (formato YYYY-MM-DD para BD y date-picker)
      fechaGeneralMostrar: "", // Campo para mostrar fecha en formato DD/MM/YYYY
      menuFechaGeneral: false, // Para el selector de fecha general en el modal de descarga
      ocNumero: "",
      proveedorSeleccionadoPorProceso: {}, // { [idProceso]: proveedor }
      showLoadingModal: false, // Modal de carga global
      fechaInicio: null,
      fechaFin: null,
      filtroActivo: false,
      procesosOriginales: [], // Para mantener todos los datos originales
      // ✅ Variables de cache para optimización
      cacheProcesos: null,
      cacheTimestamp: null,
      cacheTimeout: 30000, // 30 segundos
      // ✅ Variables para debouncing
      debounceTimeout: null,
      debounceDelay: 300, // 300ms de delay
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },

    // ✅ Debounced watchers para filtros de fecha
    fechaInicio: {
      handler: "debounceFiltros",
      immediate: false,
    },
    fechaFin: {
      handler: "debounceFiltros",
      immediate: false,
    },
    // Watchers para calcular subtotales automáticamente cuando cambian los valores
    "procesoEditado.proveedor1.valores": {
      handler() {
        this.calcularSubtotalTotalProveedor1();
      },
      deep: true,
    },
    "procesoEditado.proveedor2.valores": {
      handler() {
        this.calcularSubtotalTotalProveedor2();
      },
      deep: true,
    },
    "procesoEditado.proveedor3.valores": {
      handler() {
        this.calcularSubtotalTotalProveedor3();
      },
      deep: true,
    },
  },
  mounted() {
    this.obtenerApps();
    // Aplicar estilos personalizados después de que se monte el componente
    this.$nextTick(() => {
      this.aplicarEstilosFechaEntrega();
    });
  },

  // ✅ Cleanup de timeouts al destruir el componente
  beforeDestroy() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
  computed: {
    proveedoresDisponibles() {
      const arr = [];
      if (
        this.itemDescarga &&
        this.itemDescarga.proveedor1 &&
        this.itemDescarga.proveedor1.nombreEmpresa
      )
        arr.push({
          label: `Proveedor 1 (${this.itemDescarga.proveedor1.nombreEmpresa})`,
          value: 1,
        });
      if (
        this.itemDescarga &&
        this.itemDescarga.proveedor2 &&
        this.itemDescarga.proveedor2.nombreEmpresa
      )
        arr.push({
          label: `Proveedor 2 (${this.itemDescarga.proveedor2.nombreEmpresa})`,
          value: 2,
        });
      if (
        this.itemDescarga &&
        this.itemDescarga.proveedor3 &&
        this.itemDescarga.proveedor3.nombreEmpresa
      )
        arr.push({
          label: `Proveedor 3 (${this.itemDescarga.proveedor3.nombreEmpresa})`,
          value: 3,
        });
      return arr;
    },
    hayProveedoresDisponibles() {
      return (
        this.itemDescarga &&
        ((this.itemDescarga.proveedor1 &&
          this.itemDescarga.proveedor1.nombreEmpresa) ||
          (this.itemDescarga.proveedor2 &&
            this.itemDescarga.proveedor2.nombreEmpresa) ||
          (this.itemDescarga.proveedor3 &&
            this.itemDescarga.proveedor3.nombreEmpresa))
      );
    },
    proveedorPreview() {
      if (!this.itemDescarga || !this.proveedorSeleccionado) return null;
      // Si proveedorSeleccionado es numérico (1/2/3) devolvemos por índice
      const selNum = Number(this.proveedorSeleccionado);
      if (selNum === 1) return this.itemDescarga.proveedor1 || null;
      if (selNum === 2) return this.itemDescarga.proveedor2 || null;
      if (selNum === 3) return this.itemDescarga.proveedor3 || null;

      // Si proveedorSeleccionado es un id, buscamos dentro de proveedor1/2/3
      const candidates = [
        this.itemDescarga.proveedor1,
        this.itemDescarga.proveedor2,
        this.itemDescarga.proveedor3,
      ];
      for (const p of candidates) {
        if (!p) continue;
        const pId =
          p.id ||
          p.idProveedor ||
          p.idRegistro ||
          p.proveedorId ||
          p.proveedor_id;
        if (!pId) continue;
        if (String(pId) === String(this.proveedorSeleccionado)) return p;
      }
      return null;
    },
    procesosFiltrados() {
      return this.procesos;
    },

    // ✅ Cache para estados - mejora rendimiento en downloadExcel
    estadosCache() {
      return {
        1: "Gerencia",
        2: "Compras",
        3: "Proveedores",
        4: "Pendiente aprobación director área",
        5: "Pendiente aprobación direccion financiera",
        6: "Pendiente aprobación gerencia",
        7: "Realizar compra",
        8: "Compra realizada",
      };
    },
    // Computed para validar fecha antes de pasarla al date-picker (evita errores)
    fechaGeneralValida: {
      get() {
        // Solo retornar si tiene formato válido YYYY-MM-DD completo
        if (
          this.fechaGeneral &&
          /^\d{4}-\d{2}-\d{2}$/.test(this.fechaGeneral)
        ) {
          return this.fechaGeneral;
        }
        return null;
      },
      set(val) {
        if (val && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
          this.fechaGeneral = val;
          this.fechaGeneralMostrar = val;
        }
      },
    },
  },
  methods: {
    // Utilidad: recibe fecha en formatos comunes (YYYY-MM-DD o Date) y devuelve YYYY-MM-DD
    toYMD(fecha) {
      try {
        if (!fecha) return null;
        if (typeof fecha === "string") {
          // Si ya viene en YYYY-MM-DD lo retornamos
          if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha;
          // Si viene como DD/MM/YYYY
          if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(fecha)) {
            const [d, m, y] = fecha.split("/");
            return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(
              2,
              "0",
            )}`;
          }
          // Intento final: parsear con Date y normalizar a local sin TZ
          const dt = new Date(fecha);
          if (!isNaN(dt.getTime())) {
            const yyyy = dt.getFullYear();
            const mm = String(dt.getMonth() + 1).padStart(2, "0");
            const dd = String(dt.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
          }
          return null;
        }
        if (fecha instanceof Date && !isNaN(fecha.getTime())) {
          const yyyy = fecha.getFullYear();
          const mm = String(fecha.getMonth() + 1).padStart(2, "0");
          const dd = String(fecha.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        }
        return null;
      } catch (e) {
        return null;
      }
    },

    // Formatea YYYY-MM-DD a DD/MM/YYYY sin usar Date
    formatFechaDDMM(ymd) {
      if (!ymd) return "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
        const [y, m, d] = ymd.split("-");
        return `${parseInt(d, 10)}/${parseInt(m, 10)}/${y}`;
      }
      // Si viene en otro formato, devuelvo tal cual
      return ymd;
    },
    // Actualiza en tiempo real mientras escribe (sin normalizar)
    actualizarFechaGeneralEnTiempoReal() {
      if (this.fechaGeneralMostrar) {
        let fecha = this.fechaGeneralMostrar.trim();
        // Permitir escribir libremente, solo sincronizar fechaGeneral si tiene formato básico
        // No forzar normalización mientras escribe
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(fecha)) {
          // Solo actualizar si tiene el formato básico completo
          this.fechaGeneral = fecha;
        } else if (/^\d{4}-\d{1,2}$/.test(fecha)) {
          // Está escribiendo día, no normalizar aún
          this.fechaGeneral = fecha;
        } else if (/^\d{4}-\d{1,2}-$/.test(fecha)) {
          // Está escribiendo después del último guion, permitir
          this.fechaGeneral = fecha;
        } else if (/^\d{4}-\d{1,2}-\d{0,2}$/.test(fecha)) {
          // Permite escribir día parcial
          this.fechaGeneral = fecha;
        } else {
          // Otro formato, solo actualizar si parece válido
          this.fechaGeneral = fecha;
        }
      } else {
        this.fechaGeneral = "";
      }
    },
    // Normaliza el formato solo cuando termina de escribir (blur)
    normalizarFechaGeneral() {
      if (this.fechaGeneralMostrar) {
        let fecha = this.fechaGeneralMostrar.trim();

        // Verificar formato YYYY-MM-DD completo
        const regexYYYYMMDD = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
        const match = fecha.match(regexYYYYMMDD);

        if (match) {
          const año = parseInt(match[1], 10);
          let mes = parseInt(match[2], 10);
          let dia = parseInt(match[3], 10);

          // Validar rangos
          if (
            dia >= 1 &&
            dia <= 31 &&
            mes >= 1 &&
            mes <= 12 &&
            año >= 1900 &&
            año <= 2100
          ) {
            // Normalizar con ceros a la izquierda solo cuando tenga formato completo
            const diaStr = dia < 10 ? `0${dia}` : `${dia}`;
            const mesStr = mes < 10 ? `0${mes}` : `${mes}`;
            const fechaFormateada = `${año}-${mesStr}-${diaStr}`;
            this.fechaGeneral = fechaFormateada;
            this.fechaGeneralMostrar = fechaFormateada;
          } else {
            // Fecha inválida, mantener pero no normalizar
            this.fechaGeneral = fecha;
          }
        } else {
          // Si no tiene formato completo, mantener como está
          if (fecha) {
            this.fechaGeneral = fecha;
          }
        }
      } else {
        this.fechaGeneral = "";
      }
    },
    // Actualiza el campo mostrar cuando se selecciona del calendario
    actualizarFechaGeneralDesdeCalendario() {
      this.menuFechaGeneral = false;
      // El date-picker guarda en YYYY-MM-DD
      if (this.fechaGeneralValida) {
        this.fechaGeneral = this.fechaGeneralValida;
        this.fechaGeneralMostrar = this.fechaGeneralValida;
      } else {
        this.fechaGeneral = "";
        this.fechaGeneralMostrar = "";
      }
    },
    // Para evitar incoherencias, SIEMPRE usamos 1|2|3 como valor del radio
    // sin importar IDs internos del proveedor.
    getProveedorValue(proveedorObj, fallbackIndex) {
      return fallbackIndex;
    },
    // Descarga el PDF del checklist de seguridad de equipos generado por el backend
    // Ahora acepta opcionalmente 'proveedor' (1|2|3) y 'fechaEntrega' para que el backend
    // pueda pintar los campos correspondientes en la factura según el proveedor seleccionado.
    descargarChecklistPDF(
      idChecklist,
      proveedor,
      fechaEntrega,
      ocNumero,
      conceptosEditados,
      fechaGeneral,
    ) {
      if (!idChecklist) {
        this.$emit("showSnackbar", "No se encontró el ID del checklist.");
        return;
      }
      let url = `${env.endpoint}user/ver_pdf/${idChecklist}`;
      // Construir query params de forma segura
      const params = [];
      if (proveedor !== undefined && proveedor !== null) {
        params.push(`proveedor=${encodeURIComponent(proveedor)}`);
      }
      if (fechaEntrega) {
        params.push(`fechaEntrega=${encodeURIComponent(fechaEntrega)}`);
      }
      if (ocNumero) {
        params.push(`oc=${encodeURIComponent(ocNumero)}`);
      }
      if (
        conceptosEditados &&
        Array.isArray(conceptosEditados) &&
        conceptosEditados.length > 0
      ) {
        conceptosEditados.forEach((art, idx) => {
          params.push(`concepto_${idx}=${encodeURIComponent(art.concepto)}`);
          params.push(`cantidad_${idx}=${encodeURIComponent(art.cantidad)}`);
        });
        params.push(`total_conceptos=${conceptosEditados.length}`);
      }
      if (fechaGeneral) {
        // Convertir YYYY-MM-DD a DD/MM/YYYY para el PDF (como aparece en la imagen: 22/08/2025)
        const fechaFormateada = this.formatFechaDDMM(fechaGeneral);
        // Enviar como 'fecha' (el parámetro que el PDF espera para el campo FECHA)
        params.push(`fecha=${encodeURIComponent(fechaFormateada)}`);
        // También enviar fechaGeneral en formato YYYY-MM-DD por si el backend lo necesita
        params.push(`fechaGeneral=${encodeURIComponent(fechaGeneral)}`);
      }
      if (params.length) {
        url += `?${params.join("&")}`;
      }
      window.open(url, "_blank");
    },
    formatCurrency(value) {
      if (value !== null && value !== undefined) {
        return new Intl.NumberFormat("es-CO", {
          style: "currency",
          currency: "COP",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      }
      return "";
    },

    // 🎯 MÉTODO: Formatear valor unitario para mostrar (CON decimales) - ACTUALIZADO
    formatValorUnitario(value) {
      if (value === null || value === undefined || value === "") return "$ 0";

      // Convertir a número usando nuestro método que maneja comas como decimales
      const numero = this.obtenerValorNumerico(value);

      if (isNaN(numero)) return "$ 0";

      // Formatear con el formato colombiano (puntos para miles, coma para decimales)
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2, // ✅ Permitir hasta 2 decimales
      }).format(numero);
    },

    // 🎯 MÉTODO: Obtener valor numérico limpio (maneja comas como decimales y puntos como miles)
    obtenerValorNumerico(valorFormateado) {
      if (!valorFormateado) return 0;

      // Si es string, convertir a número
      if (typeof valorFormateado === "string") {
        // Reemplazar puntos (separadores de miles) por nada
        let valorLimpio = valorFormateado.replace(/\./g, "");

        // Reemplazar coma (separador decimal) por punto para parseFloat
        valorLimpio = valorLimpio.replace(",", ".");

        return parseFloat(valorLimpio) || 0;
      }

      // Si ya es número, devolverlo
      return parseFloat(valorFormateado) || 0;
    },

    // Método para abrir el modal de edición
    async editarProceso(item) {
      try {
        this.loadingUpdate = true;

        // Usar el ID correcto del proceso
        const procesoId =
          item.idProceso !== null ? item.idProceso : item.idProceso_procesos;

        // Intentar usar los datos que ya tenemos en el item
        if (item) {
          this.procesoEditado = JSON.parse(JSON.stringify(item)); // Deep copy

          // Normalizar valores unitarios antes de inicializar
          this.normalizarValoresUnitarios();

          // Asegurar que cada proveedor tenga la estructura correcta
          this.inicializarProveedores();

          this.dialogEditProceso = true;

          // Inicializar archivos
          this.nuevaImagen1 = null;
          this.nuevaImagen2 = null;
          this.nuevaImagen3 = null;
        } else {
          swal({
            title: "Error",
            text: "No se pudo cargar el proceso",
            icon: "error",
            button: "Cerrar",
          });
        }
      } catch (error) {
        console.error("Error al cargar proceso:", error);
        swal({
          title: "Error",
          text: "Error al cargar los datos del proceso",
          icon: "error",
          button: "Cerrar",
        });
      } finally {
        this.loadingUpdate = false;
      }
    },

    // Método para cerrar el modal de edición
    cerrarEditarProceso() {
      this.dialogEditProceso = false;
      this.procesoEditado = {
        proveedor1: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
        proveedor2: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
        proveedor3: {
          nombreEmpresa: "",
          subTotal: 0,
          iva: 0,
          total: 0,
        },
      };
      this.nuevaImagen1 = null;
      this.nuevaImagen2 = null;
      this.nuevaImagen3 = null;
    },

    // Método para calcular totales automáticamente
    calcularTotal(proveedor) {
      const subtotal = parseFloat(proveedor.subTotal) || 0;
      const iva = parseFloat(proveedor.iva) || 0;
      proveedor.total = subtotal + iva;
    },

    // Método para formatear moneda con separador de miles (puntos) en el input
    formatearMoneda(valor, proveedor, index) {
      const valorStr = (valor ?? "").toString();
      // Remover todo excepto dígitos
      let soloDigitos = valorStr.replace(/[^\d]/g, "");
      if (soloDigitos === "") soloDigitos = "0";

      // Agregar separador de miles con puntos
      const conPuntos = soloDigitos.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      // Guardar el valor formateado en el campo (string con puntos)
      this.$set(
        this.procesoEditado[proveedor].valores[index],
        "valorUnitario",
        conPuntos,
      );
    },

    // Método auxiliar para formatear números con puntos
    formatearNumeroConPuntos(numero) {
      // Si el número tiene decimales, no agregar puntos de miles
      if (numero.toString().includes(".")) {
        return numero.toString();
      }
      // Solo agregar puntos si es un número entero
      return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // Método auxiliar para convertir valor formateado a número
    convertirANumero(valorFormateado) {
      if (!valorFormateado) return 0;
      // Si ya es un número, devolverlo directamente
      if (typeof valorFormateado === "number") return valorFormateado;
      // Si es string, limpiar y convertir
      return parseFloat(valorFormateado.toString().replace(/\./g, "")) || 0;
    },

    // Método para normalizar valores unitarios al cargar el proceso
    normalizarValoresUnitarios() {
      const proveedores = ["proveedor1", "proveedor2", "proveedor3"];

      proveedores.forEach((proveedorKey) => {
        if (
          this.procesoEditado[proveedorKey] &&
          this.procesoEditado[proveedorKey].valores
        ) {
          this.procesoEditado[proveedorKey].valores.forEach((valor) => {
            if (valor.valorUnitario) {
              // Convertir string con puntos a número
              if (typeof valor.valorUnitario === "string") {
                valor.valorUnitario = this.convertirANumero(
                  valor.valorUnitario,
                );
              }
            }
          });
        }
      });
    },

    // Métodos para calcular subtotales por proveedor
    calcularSubtotalProveedor1(index) {
      if (!this.procesoEditado.proveedor1.valores) return;

      const cantidad =
        parseFloat(this.procesoEditado.infoProceso[index].cantidad) || 1;
      const valorUnitario = this.convertirANumero(
        this.procesoEditado.proveedor1.valores[index].valorUnitario,
      );
      const subtotalProducto = cantidad * valorUnitario;

      // Actualizar el subtotal del producto
      this.procesoEditado.proveedor1.valores[index].subtotal = subtotalProducto;
      this.procesoEditado.proveedor1.valores[index].valorTotal =
        subtotalProducto;

      // Calcular el subtotal total del proveedor
      this.calcularSubtotalTotalProveedor1();
    },

    calcularSubtotalProveedor2(index) {
      if (!this.procesoEditado.proveedor2.valores) return;

      const cantidad =
        parseFloat(this.procesoEditado.infoProceso[index].cantidad) || 1;
      const valorUnitario = this.convertirANumero(
        this.procesoEditado.proveedor2.valores[index].valorUnitario,
      );
      const subtotalProducto = cantidad * valorUnitario;

      // Actualizar el subtotal del producto
      this.procesoEditado.proveedor2.valores[index].subtotal = subtotalProducto;
      this.procesoEditado.proveedor2.valores[index].valorTotal =
        subtotalProducto;

      // Calcular el subtotal total del proveedor
      this.calcularSubtotalTotalProveedor2();
    },

    calcularSubtotalProveedor3(index) {
      if (!this.procesoEditado.proveedor3.valores) return;

      const cantidad =
        parseFloat(this.procesoEditado.infoProceso[index].cantidad) || 1;
      const valorUnitario = this.convertirANumero(
        this.procesoEditado.proveedor3.valores[index].valorUnitario,
      );
      const subtotalProducto = cantidad * valorUnitario;

      // Actualizar el subtotal del producto
      this.procesoEditado.proveedor3.valores[index].subtotal = subtotalProducto;
      this.procesoEditado.proveedor3.valores[index].valorTotal =
        subtotalProducto;

      // Calcular el subtotal total del proveedor
      this.calcularSubtotalTotalProveedor3();
    },

    // Métodos para calcular el subtotal total de cada proveedor
    calcularSubtotalTotalProveedor1() {
      let total = 0;
      if (this.procesoEditado.proveedor1.valores) {
        this.procesoEditado.proveedor1.valores.forEach((valor) => {
          total += parseFloat(valor.subtotal) || 0;
        });
      }
      this.procesoEditado.proveedor1.subTotal = total;
      this.procesoEditado.proveedor1.total = total; // Sin IVA
    },

    calcularSubtotalTotalProveedor2() {
      let total = 0;
      if (this.procesoEditado.proveedor2.valores) {
        this.procesoEditado.proveedor2.valores.forEach((valor) => {
          total += parseFloat(valor.subtotal) || 0;
        });
      }
      this.procesoEditado.proveedor2.subTotal = total;
      this.procesoEditado.proveedor2.total = total; // Sin IVA
    },

    calcularSubtotalTotalProveedor3() {
      let total = 0;
      if (this.procesoEditado.proveedor3.valores) {
        this.procesoEditado.proveedor3.valores.forEach((valor) => {
          total += parseFloat(valor.subtotal) || 0;
        });
      }
      this.procesoEditado.proveedor3.subTotal = total;
      this.procesoEditado.proveedor3.total = total; // Sin IVA
    },

    // Método para guardar los cambios
    async guardarCambiosProceso() {
      try {
        this.loadingUpdate = true;

        // ✅ 1. PRIMERO: Calcular totales y normalizar (¡ESTO FALTABA!)
        this.calcularTotal(this.procesoEditado.proveedor1);
        this.calcularTotal(this.procesoEditado.proveedor2);
        this.calcularTotal(this.procesoEditado.proveedor3);
        this.normalizarValoresUnitariosAntesDeGuardar();

        // ✅ 2. Subir imágenes si hay nuevas
        if (this.nuevaImagen1 || this.nuevaImagen2 || this.nuevaImagen3) {
          try {
            await this.subirImagenesProveedores();
            console.log("✅ Imágenes subidas");
          } catch (error) {
            console.error("❌ Error al subir imágenes:", error);
            swal({
              title: "Error",
              text: "No se pudieron subir las imágenes. No se guardaron los cambios.",
              icon: "error",
              button: "Cerrar",
            });
            this.loadingUpdate = false;
            return;
          }
        }

        // ✅ 3. Crear objeto con SOLO los proveedores que tienen datos
        const proveedoresData = {};

        if (
          this.procesoEditado.proveedor1 &&
          (this.procesoEditado.proveedor1.nombreEmpresa ||
            (this.procesoEditado.proveedor1.valores &&
              this.procesoEditado.proveedor1.valores.length > 0))
        ) {
          proveedoresData.proveedor1 = this.procesoEditado.proveedor1;
        }

        if (
          this.procesoEditado.proveedor2 &&
          (this.procesoEditado.proveedor2.nombreEmpresa ||
            (this.procesoEditado.proveedor2.valores &&
              this.procesoEditado.proveedor2.valores.length > 0))
        ) {
          proveedoresData.proveedor2 = this.procesoEditado.proveedor2;
        }

        if (
          this.procesoEditado.proveedor3 &&
          (this.procesoEditado.proveedor3.nombreEmpresa ||
            (this.procesoEditado.proveedor3.valores &&
              this.procesoEditado.proveedor3.valores.length > 0))
        ) {
          proveedoresData.proveedor3 = this.procesoEditado.proveedor3;
        }

        // ✅ 4. Observación (solo si es válida)
        if (
          this.procesoEditado.observacion &&
          this.procesoEditado.observacion !== "Solo se actualizó el proveedor 1"
        ) {
          proveedoresData.observacion = this.procesoEditado.observacion;
        }

        // ✅ 5. Enviar al backend
        const response = await axios.post(
          `${env.endpoint}user/actualizarProceso`,
          {
            idProceso: this.procesoEditado.idProceso,
            dataProveedores: proveedoresData,
          },
          { headers: { "Content-Type": "application/json" } },
        );

        if (response.data.estado) {
          swal({
            title: "Éxito",
            text: "Proceso actualizado correctamente",
            icon: "success",
            timer: 1500,
          });

          this.cerrarEditarProceso();
          this.cacheProcesos = null;
          this.cacheTimestamp = null;
          await this.obtenerApps();
        }
      } catch (error) {
        console.error("Error:", error);
        swal({
          title: "Error",
          text: "Error al guardar los cambios",
          icon: "error",
        });
      } finally {
        this.loadingUpdate = false;
      }
    },

    // ✅ Método para normalizar valores unitarios antes de guardar
    // Convierte strings formateados (ej: "80.000") a números (80000)
    // Esto evita que el backend interprete mal el formato al generar el PDF
    normalizarValoresUnitariosAntesDeGuardar() {
      const proveedores = ["proveedor1", "proveedor2", "proveedor3"];

      proveedores.forEach((proveedorKey) => {
        if (
          this.procesoEditado[proveedorKey] &&
          this.procesoEditado[proveedorKey].valores &&
          Array.isArray(this.procesoEditado[proveedorKey].valores)
        ) {
          this.procesoEditado[proveedorKey].valores.forEach((valor) => {
            if (
              valor.valorUnitario !== undefined &&
              valor.valorUnitario !== null
            ) {
              // Si es string formateado (ej: "80.000"), convertirlo a número
              if (typeof valor.valorUnitario === "string") {
                // Remover todos los puntos (separadores de miles en formato colombiano)
                const valorSinPuntos = valor.valorUnitario.replace(/\./g, "");
                // Reemplazar coma decimal por punto (si existe)
                const valorSinComa = valorSinPuntos.replace(",", ".");
                // Convertir a número
                const valorNumerico = parseFloat(valorSinComa);
                // Guardar como número (sin formato)
                valor.valorUnitario = isNaN(valorNumerico) ? 0 : valorNumerico;
              }
              // Si ya es número, mantenerlo como está
              else if (typeof valor.valorUnitario === "number") {
                valor.valorUnitario = valor.valorUnitario;
              }
            }
          });
        }
      });
    },

    // Método para subir todas las imágenes de proveedores
    async subirImagenesProveedores() {
      const promesasSubida = [];
      const resultados = {
        proveedor1: null,
        proveedor2: null,
        proveedor3: null,
      };

      try {
        // Subir imagen proveedor 1 si fue seleccionada
        if (this.nuevaImagen1) {
          try {
            const resultado = await this.subirImagenProveedor1(
              this.nuevaImagen1,
              this.procesoEditado.idProceso,
            );
            resultados.proveedor1 = resultado;
            console.log("✅ Imagen 1 subida:", resultado);
          } catch (error) {
            console.error("Error subiendo imagen proveedor 1:", error);
            throw new Error("Error al subir imagen del proveedor 1");
          }
        }

        // Subir imagen proveedor 2 si fue seleccionada
        if (this.nuevaImagen2) {
          try {
            const resultado = await this.subirImagenProveedor2(
              this.nuevaImagen2,
              this.procesoEditado.idProceso,
            );
            resultados.proveedor2 = resultado;
            console.log("✅ Imagen 2 subida:", resultado);
          } catch (error) {
            console.error("Error subiendo imagen proveedor 2:", error);
            throw new Error("Error al subir imagen del proveedor 2");
          }
        }

        // Subir imagen proveedor 3 si fue seleccionada
        if (this.nuevaImagen3) {
          try {
            const resultado = await this.subirImagenProveedor3(
              this.nuevaImagen3,
              this.procesoEditado.idProceso,
            );
            resultados.proveedor3 = resultado;
            console.log("✅ Imagen 3 subida:", resultado);
          } catch (error) {
            console.error("Error subiendo imagen proveedor 3:", error);
            throw new Error("Error al subir imagen del proveedor 3");
          }
        }

        return resultados;
      } catch (error) {
        console.error("Error general subiendo imágenes:", error);
        throw error; // Re-lanzar para que guardarCambiosProceso lo capture
      }
    },

    // Función para subir imagen de proveedor 1
    async subirImagenProveedor1(archivo, idProceso) {
      console.log("📤 Enviando archivo:", archivo.name);
      console.log("📤 idProceso:", idProceso);

      const formData = new FormData();
      formData.append("ruta_img1", archivo);
      formData.append("idProceso", idProceso);

      try {
        const response = await axios.post(
          `${env.uploadBase}archivos/upload.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        console.log("✅ Respuesta del servidor:", response.data);

        if (response.data.status === "success") {
          // 🔥 ACTUALIZAR LA RUTA EN EL OBJETO procesoEditado
          // La ruta de la imagen se guarda en proveedor1.ruta_img
          if (this.procesoEditado.proveedor1) {
            // Crear la propiedad ruta_img si no existe
            if (!this.procesoEditado.proveedor1.ruta_img) {
              this.$set(
                this.procesoEditado.proveedor1,
                "ruta_img",
                response.data.path,
              );
            } else {
              this.procesoEditado.proveedor1.ruta_img = response.data.path;
            }

            // 🔥 TAMBIÉN actualizar la propiedad ruta_img1 del proceso principal (si existe)
            // Esto es para mantener compatibilidad con el resto del código
            if (this.procesoEditado.ruta_img1) {
              this.procesoEditado.ruta_img1 = response.data.path;
            }

            console.log(
              "✅ Ruta actualizada en procesoEditado:",
              this.procesoEditado.proveedor1.ruta_img,
            );
          }

          return response.data;
        } else {
          throw new Error(response.data.message || "Error al subir imagen");
        }
      } catch (error) {
        console.error("❌ Error en subirImagenProveedor1:", error);
        if (error.response) {
          console.error("❌ Respuesta del servidor:", error.response.data);
        }
        throw error;
      }
    },

    // Función para subir imagen de proveedor 2
    async subirImagenProveedor2(archivo, idProceso) {
      console.log("📤 Enviando archivo proveedor 2:", archivo.name);
      console.log("📤 idProceso:", idProceso);

      const formData = new FormData();
      formData.append("ruta_img2", archivo);
      formData.append("idProceso", idProceso);

      try {
        const response = await axios.post(
          `${env.uploadBase}archivos/upload2.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        console.log("✅ Respuesta del servidor (prov2):", response.data);

        if (response.data.status === "success") {
          // 🔥 ACTUALIZAR LA RUTA EN proveedor2.ruta_img
          if (this.procesoEditado.proveedor2) {
            if (!this.procesoEditado.proveedor2.ruta_img) {
              this.$set(
                this.procesoEditado.proveedor2,
                "ruta_img",
                response.data.path,
              );
            } else {
              this.procesoEditado.proveedor2.ruta_img = response.data.path;
            }
            console.log(
              "✅ Ruta proveedor 2 actualizada:",
              this.procesoEditado.proveedor2.ruta_img,
            );
          }
          return response.data;
        } else {
          throw new Error(
            response.data.message || "Error al subir imagen proveedor 2",
          );
        }
      } catch (error) {
        console.error("❌ Error en subirImagenProveedor2:", error);
        throw error;
      }
    },

    // Función para subir imagen de proveedor 3
    async subirImagenProveedor3(archivo, idProceso) {
      console.log("📤 Enviando archivo proveedor 3:", archivo.name);
      console.log("📤 idProceso:", idProceso);

      const formData = new FormData();
      formData.append("ruta_img3", archivo);
      formData.append("idProceso", idProceso);

      try {
        const response = await axios.post(
          `${env.uploadBase}archivos/upload3.php`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        console.log("✅ Respuesta del servidor (prov3):", response.data);

        if (response.data.status === "success") {
          // 🔥 ACTUALIZAR LA RUTA EN proveedor3.ruta_img
          if (this.procesoEditado.proveedor3) {
            if (!this.procesoEditado.proveedor3.ruta_img) {
              this.$set(
                this.procesoEditado.proveedor3,
                "ruta_img",
                response.data.path,
              );
            } else {
              this.procesoEditado.proveedor3.ruta_img = response.data.path;
            }
            console.log(
              "✅ Ruta proveedor 3 actualizada:",
              this.procesoEditado.proveedor3.ruta_img,
            );
          }
          return response.data;
        } else {
          throw new Error(
            response.data.message || "Error al subir imagen proveedor 3",
          );
        }
      } catch (error) {
        console.error("❌ Error en subirImagenProveedor3:", error);
        throw error;
      }
    },

    // Método para validar tipos de archivo
    validarTipoArchivo(archivo) {
      if (!archivo || !archivo.type) return false;
      const tiposPermitidos = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      return tiposPermitidos.includes(archivo.type);
    },

    // Método para manejar selección de archivos
    onArchivoSeleccionado(event, proveedor) {
      const archivo = event.target.files[0];
      if (!archivo) return;

      if (!this.validarTipoArchivo(archivo)) {
        swal({
          title: "Archivo no válido",
          text: "Solo se permiten archivos: JPG, JPEG, PNG, GIF, PDF, DOC, DOCX, XLS, XLSX",
          icon: "warning",
          button: "Cerrar",
        });

        // Limpiar el archivo seleccionado
        if (proveedor === 1) this.nuevaImagen1 = null;
        if (proveedor === 2) this.nuevaImagen2 = null;
        if (proveedor === 3) this.nuevaImagen3 = null;

        return;
      }

      // Asignar el archivo a la variable correspondiente
      if (proveedor === 1) {
        this.nuevaImagen1 = archivo;
      } else if (proveedor === 2) {
        this.nuevaImagen2 = archivo;
      } else if (proveedor === 3) {
        this.nuevaImagen3 = archivo;
      }
    },

    habilitar(item) {
      swal({
        title: " Habilitar compra",
        text: "¿Está seguro de habilitar esta compra?",
        icon: "warning",
        buttons: ["Cancelar", true],
      }).then((willDelete) => {
        if (willDelete) {
          const idproceso = item.idProceso;
          let formData = new FormData();
          formData.append("idProceso", idproceso);

          axios
            .post(`${env.endpoint}user/habilitarEstado`, formData)
            .then((res) => {
              swal("Se ha habilitado con exito!", {
                icon: "success",
                timer: 1000,
              });
              this.refrescarApps();
            });
        }
      });
    },

    editItem2(item) {
      if (!item.proveedor1 && !item.Proveedor2 && !item.proveedor3) {
        swal({
          title: "No puedes visualizar",
          text: "Datos Cancelados",
          icon: "warning",
          button: "Cerrar",
        });
        return;
      } else {
        this.editedIndex = this.procesos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialogEdit = true;
      }
    },

    updateProvedores123() {
      let formData = new FormData();
      formData.append("idRegistro", this.editedItem.idRegistro);

      formData.append(
        "proveedor1_nombreEmpresa",
        this.editedItem.proveedor1.nombreEmpresa,
      );
      formData.append(
        "proveedor1_contacto",
        this.editedItem.proveedor1.contacto,
      );
      formData.append(
        "proveedor1_direccion",
        this.editedItem.proveedor1.direccion,
      );
      formData.append("proveedor1_ciudad", this.editedItem.proveedor1.ciudad);

      if (
        this.editedItem.proveedor1 &&
        this.editedItem.proveedor1.valores &&
        (this.editedItem.proveedor1.valores.subtotal !== undefined ||
          this.editedItem.proveedor1.valores.valorTotal !== undefined ||
          this.editedItem.proveedor1.valores.iva !== undefined)
      ) {
        formData.append(
          "proveedor1valoressubtotal",
          this.editedItem.proveedor1.valores.subtotal,
        );
        formData.append(
          "proveedor1valoresvalorTotal",
          this.editedItem.proveedor1.valores.valorTotal,
        );
        formData.append(
          "proveedor1valoresiva",
          this.editedItem.proveedor1.valores.iva,
        );
      }
      formData.append(
        "proveedor1_subTotal",
        this.editedItem.proveedor1.subTotal,
      );
      formData.append("proveedor1_total", this.editedItem.proveedor1.total);

      formData.append(
        "proveedor2_nombreEmpresa",
        this.editedItem.proveedor2.nombreEmpresa,
      );
      formData.append(
        "proveedor2_contacto",
        this.editedItem.proveedor2.contacto,
      );
      formData.append(
        "proveedor2_direccion",
        this.editedItem.proveedor2.direccion,
      );
      formData.append("proveedor2_ciudad", this.editedItem.proveedor2.ciudad);
      if (
        this.editedItem.proveedor2 &&
        this.editedItem.proveedor2.valores &&
        (this.editedItem.proveedor2.valores.subtotal !== undefined ||
          this.editedItem.proveedor2.valores.valorTotal !== undefined ||
          this.editedItem.proveedor2.valores.iva !== undefined)
      ) {
        formData.append(
          "proveedor2valoressubtotal",
          this.editedItem.proveedor2.valores.subtotal,
        );
        formData.append(
          "proveedor2valoresvalorTotal",
          this.editedItem.proveedor2.valores.valorTotal,
        );
        formData.append(
          "proveedor2valoresiva",
          this.editedItem.proveedor2.valores.iva,
        );
      }
      formData.append(
        "proveedor2_subTotal",
        this.editedItem.proveedor2.subTotal,
      );
      formData.append("proveedor2_total", this.editedItem.proveedor2.total);

      formData.append(
        "proveedor3_nombreEmpresa",
        this.editedItem.proveedor3.nombreEmpresa,
      );
      formData.append(
        "proveedor3_contacto",
        this.editedItem.proveedor3.contacto,
      );
      formData.append(
        "proveedor3_direccion",
        this.editedItem.proveedor3.direccion,
      );
      formData.append("proveedor3_ciudad", this.editedItem.proveedor3.ciudad);
      if (
        this.editedItem.proveedor3 &&
        this.editedItem.proveedor3.valores &&
        (this.editedItem.proveedor3.valores.subtotal !== undefined ||
          this.editedItem.proveedor3.valores.valorTotal !== undefined ||
          this.editedItem.proveedor3.valores.iva !== undefined)
      ) {
        formData.append(
          "proveedor3valoressubtotal",
          this.editedItem.proveedor3.valores.subtotal,
        );
        formData.append(
          "proveedor3valoresvalorTotal",
          this.editedItem.proveedor3.valores.valorTotal,
        );
        formData.append(
          "proveedor3valoresiva",
          this.editedItem.proveedor3.valores.iva,
        );
      }
      formData.append(
        "proveedor3_subTotal",
        this.editedItem.proveedor3.subTotal,
      );
      formData.append("proveedor3_total", this.editedItem.proveedor3.total);

      axios
        .post(`${env.endpoint}user/updateSuppliers123`, formData)
        .then((res) => {
          this.updateSuppliers = res.data;
          if (res.data.estado == true) {
            swal({
              title: "Actualizado",
              text: "Datos Actualizado satisfactoriamente",
              icon: "success",
              timer: 1500,
              buttons: ["Cancelar", true],
            })
              .then(() => {
                this.dialogEdit = false;
              })
              .catch((error) => {
                this.dialogEdit = false;
              });
          } else if (res.data.estado === false) {
            swal({
              title: "Error!",
              text: res.data.message,
              icon: "error",
              button: "Cerrar",
            }).catch((error) => {
              this.dialogEdit = false;
            });
          }
        });
    },

    close2() {
      this.dialogEdit = false;
    },
    verArchivos(item) {
      if (Array.isArray(item.ruta_img)) {
        this.archivosModal = item.ruta_img;
      } else if (item.ruta_img) {
        if (typeof item.ruta_img === "string" && item.ruta_img.includes(",")) {
          this.archivosModal = item.ruta_img.split(",").map((s) => s.trim());
        } else {
          this.archivosModal = [item.ruta_img];
        }
      } else {
        this.archivosModal = [];
      }
      this.dialogArchivos = true;
    },
    esImagen(archivo) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(archivo);
    },
    nombreArchivo(archivo) {
      return archivo.split("/").pop();
    },
    abrirArchivo(archivo) {
      window.open(archivo, "_blank");
    },

    obtenerApps() {
      const now = Date.now();

      if (
        this.cacheProcesos &&
        this.cacheTimestamp &&
        now - this.cacheTimestamp < this.cacheTimeout
      ) {
        this.procesosOriginales = this.cacheProcesos;
        this.aplicarFiltrosPorDefecto();
        return Promise.resolve();
      }

      return axios
        .get(`${env.endpoint}user/allProcesos`)
        .then((res) => {
          // ✅ AQUÍ ESTÁ LA CLAVE
          const data = Array.isArray(res.data) ? res.data : [];

          this.cacheProcesos = data;
          this.cacheTimestamp = now;
          this.procesosOriginales = data;

          this.aplicarFiltrosPorDefecto();
        })
        .catch((err) => {
          console.error("Error al obtener procesos:", err);

          // 🔐 fallback seguro
          this.procesosOriginales = [];
          this.procesos = [];
        });
    },
    // ✅ Método optimizado para aplicar filtros por defecto
    aplicarFiltrosPorDefecto() {
      console.log("🧪 aplicarFiltrosPorDefecto() llamado");
      console.log("🧪 procesosOriginales:", this.procesosOriginales);
      console.log("🧪 tipo:", typeof this.procesosOriginales);
      console.log("🧪 es array:", Array.isArray(this.procesosOriginales));

      if (!Array.isArray(this.procesosOriginales)) {
        console.error(
          "❌ procesosOriginales NO es array:",
          this.procesosOriginales,
        );
        this.procesosOriginales = [];
      }

      const fechaActual = new Date();
      const mesActual = fechaActual.getMonth() + 1;
      const añoActual = fechaActual.getFullYear();

      const mesAnterior1 = mesActual === 1 ? 12 : mesActual - 1;
      const añoAnterior1 = mesActual === 1 ? añoActual - 1 : añoActual;

      const mesAnterior2 = mesAnterior1 === 1 ? 12 : mesAnterior1 - 1;
      const añoAnterior2 = mesAnterior1 === 1 ? añoAnterior1 - 1 : añoAnterior1;

      this.procesos = this.procesosOriginales
        .filter((p) => p && p.estado !== 0) // 👈 soft delete
        .filter((p) =>
          this.filtrarPorFecha(
            p,
            mesActual,
            añoActual,
            mesAnterior1,
            añoAnterior1,
            mesAnterior2,
            añoAnterior2,
          ),
        )
        .map((p) => this.transformarProceso(p));

      this.inicializarProveedorSeleccionado();

      this.$nextTick(() => {
        this.aplicarEstilosFechaEntrega();
      });
    },

    // ✅ Método helper para filtrar fechas
    filtrarPorFecha(
      proceso,
      mesActual,
      añoActual,
      mesAnterior1,
      añoAnterior1,
      mesAnterior2,
      añoAnterior2,
    ) {
      if (!proceso.fechaCreacion) return false;

      const fechaCreacion = this.parsearFecha(proceso.fechaCreacion);
      if (isNaN(fechaCreacion.getTime())) return false;

      const mesProceso = fechaCreacion.getMonth() + 1;
      const añoProceso = fechaCreacion.getFullYear();

      return (
        (mesProceso === mesActual && añoProceso === añoActual) ||
        (mesProceso === mesAnterior1 && añoProceso === añoAnterior1) ||
        (mesProceso === mesAnterior2 && añoProceso === añoAnterior2)
      );
    },

    // ✅ Método helper para parsear fechas
    parsearFecha(fechaStr) {
      if (typeof fechaStr === "string") {
        if (/^\d{4}-\d{2}-\d{2}$/.test(fechaStr)) {
          return new Date(fechaStr);
        } else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(fechaStr)) {
          const [dia, mes, año] = fechaStr.split("/");
          return new Date(año, mes - 1, dia);
        }
      }
      return new Date(fechaStr);
    },

    // ✅ Método helper para transformar procesos
    transformarProceso(proceso) {
      // Inicializar propiedades
      if (!proceso.hasOwnProperty("menuFecha")) {
        this.$set(proceso, "menuFecha", false);
      }

      // Formatear fecha
      if (proceso.fechaEntrega) {
        const ymd = this.toYMD(proceso.fechaEntrega);
        proceso.fechaEntregaFormatted = ymd || null;
      } else {
        proceso.fechaEntregaFormatted = null;
      }

      // Hidratar número de O.C
      proceso.ocNumero =
        proceso.ocNumero ||
        proceso.oc ||
        proceso.numeroOC ||
        proceso.oc_nro ||
        null;

      // ✅ Optimizar concatenación de conceptos y empresas
      if (proceso.infoProceso && Array.isArray(proceso.infoProceso)) {
        const conceptos = [];
        const empresas = new Set();
        const observaciones = [];

        proceso.infoProceso.forEach((element) => {
          if (element.concepto) conceptos.push(element.concepto);
          if (element.empresa) empresas.add(element.empresa);
          if (element.observaciones) observaciones.push(element.observaciones);
        });

        proceso.infoConcepto = conceptos.join(",");
        proceso.empresa = Array.from(empresas).join(", ");
        proceso.observaciones = observaciones.join(", ");
      } else {
        proceso.infoConcepto = "";
        proceso.empresa = "";
        proceso.observaciones = "";
      }

      return proceso;
    },

    // ✅ Método helper para inicializar proveedor seleccionado
    inicializarProveedorSeleccionado() {
      this.proveedorSeleccionadoPorProceso = {};
      this.procesos.forEach((proc) => {
        if (proc.proveedorSeleccionado) {
          this.$set(
            this.proveedorSeleccionadoPorProceso,
            proc.idProceso,
            proc.proveedorSeleccionado,
          );
        }
      });
    },

    aplicarFiltroFechas() {
      if (!this.fechaInicio || !this.fechaFin) {
        this.filtroActivo = false;
        return;
      }

      const fechaInicio = new Date(this.fechaInicio);
      const fechaFin = new Date(this.fechaFin);

      // Validar que fecha inicio sea menor que fecha fin
      if (fechaInicio > fechaFin) {
        swal({
          title: "Error",
          text: "La fecha de inicio debe ser menor que la fecha de fin",
          icon: "error",
          button: "Cerrar",
        });
        return;
      }

      // ✅ Usar cache y filtros optimizados
      this.procesos = this.procesosOriginales
        .filter((proceso) =>
          this.filtrarPorRangoFechas(proceso, fechaInicio, fechaFin),
        )
        .map((proceso) => this.transformarProceso(proceso));

      this.inicializarProveedorSeleccionado();
      this.filtroActivo = true;
    },

    // ✅ Método helper para filtrar por rango de fechas
    filtrarPorRangoFechas(proceso, fechaInicio, fechaFin) {
      if (!proceso.fechaCreacion) return false;

      const fechaCreacion = this.parsearFecha(proceso.fechaCreacion);
      if (isNaN(fechaCreacion.getTime())) return false;

      // Verificar si está dentro del rango
      return fechaCreacion >= fechaInicio && fechaCreacion <= fechaFin;
    },

    // ✅ Método debounced para filtros
    debounceFiltros() {
      // Limpiar timeout anterior
      clearTimeout(this.debounceTimeout);

      // Establecer nuevo timeout
      this.debounceTimeout = setTimeout(() => {
        if (this.fechaInicio && this.fechaFin) {
          this.aplicarFiltroFechas();
        } else if (!this.fechaInicio && !this.fechaFin) {
          this.limpiarFiltroFechas();
        }
      }, this.debounceDelay);
    },

    // ✅ Método helper para refrescar datos (con cache invalidado)
    async refrescarApps() {
      console.log("🧪 refrescarApps() llamado");
      this.cacheProcesos = null;
      this.cacheTimestamp = null;
      await this.obtenerApps();
    },
    limpiarFiltroFechas() {
      this.fechaInicio = null;
      this.fechaFin = null;
      this.filtroActivo = false;

      // ✅ Usar cache en lugar de recargar desde servidor
      this.aplicarFiltrosPorDefecto();
    },

    rechazoItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_observaciones = true;
    },

    editItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    close1() {
      this.dialogRechazar = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    mostrarFechaEntrega(item) {
      this.show = true;
      this.item = item;
      this.fechaEntrega = null;
      this.fechaEntregaError = false;
    },

    cancelar() {
      this.show = false;
    },

    realizarCompra(item) {
      swal({
        title: "¿Deseas continuar?",
        text: "¿Quieres realizar esta compra?",
        icon: "warning",
        buttons: ["Cancelar", true],
      }).then((willDelete) => {
        if (willDelete) {
          // Mostrar modal de procesando compra inmediatamente
          this.showLoadingModal = true;
          this.isLoading = true;

          const formData = new FormData();
          formData.append("idProceso", item.idProceso);
          formData.append("fechaEntrega", this.fechaEntrega);
          formData.append("estado", 8);
          formData.append("idUsuario", item.idUsuario);

          axios
            .post(`${env.endpoint}user/compraRealizar`, formData, {})
            .then((res) => {
              // Cerrar el modal de carga
              this.showLoadingModal = false;

              // Mostrar mensaje de éxito
              swal("Se ha enviado con exito!", {
                icon: "success",
              });

              // ✅ Refrescar la tabla completa con los datos frescos del servidor
              this.refrescarApps();
              this.close();
            })
            .catch((error) => {
              // Cerrar el modal de carga en caso de error
              this.showLoadingModal = false;

              swal({
                title: "Error",
                text: "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas",
                icon: "error",
                button: "Cerrar",
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.close();
            });
        } else {
          swal("Proceso de enviado sea cancelado");
        }
      });
    },

    viewImage(ruta) {
      // Si recibimos una ruta directamente, la usamos
      if (ruta) {
        window.open(ruta, "_blank");
        return;
      }

      // Si no, buscamos en los proveedores del editedItem
      if (this.editedItem.proveedor1 && this.editedItem.proveedor1.ruta_img) {
        window.open(this.editedItem.proveedor1.ruta_img, "_blank");
      } else if (
        this.editedItem.proveedor2 &&
        this.editedItem.proveedor2.ruta_img
      ) {
        window.open(this.editedItem.proveedor2.ruta_img, "_blank");
      } else if (
        this.editedItem.proveedor3 &&
        this.editedItem.proveedor3.ruta_img
      ) {
        window.open(this.editedItem.proveedor3.ruta_img, "_blank");
      } else {
        console.warn("No hay ruta de imagen disponible");
      }
    },

    viewImageDirector(item) {
      window.open(item.ruta_img, "_blank");
    },

    aceptar(item) {
      swal({
        title: "Aceptar proceso",
        text: "Proceso aceptado satisfactoriamente",
        icon: "success",
        buttons: ["Cancelar", true],
      }).then((willDelete) => {
        if (willDelete) {
          const aceptar = new FormData();
          aceptar.append("idUser", localStorage.getItem("id"));
          aceptar.append("firma", localStorage.getItem("firma"));
          aceptar.append("rol", "DIRECTOR AREA");
          aceptar.append("idProceso", item.idProceso);
          aceptar.append("estado", 5);
          axios
            .post(`${env.endpoint}user/enviarAprobacion`, aceptar, {})
            .then((res) => {
              swal("Se ha enviado con exito!", {
                icon: "success",
              });
              // Actualización automática sin recargar la página
              this.procesos = res.data;
              // ✅ Pequeño delay para mostrar el cambio de estado
              setTimeout(() => {
                this.refrescarApps();
              }, 500);
              this.close();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.close();
              this.refrescarApps();
            });
        } else {
          swal("Proceso de eviado sea cancelado");
        }
      });
    },

    rechazar(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogRechazar = true;
    },

    rechazarProceso(item) {
      const aceptar = new FormData();
      aceptar.append("idUser", localStorage.getItem("id"));
      aceptar.append("observacion", this.observaciones);
      aceptar.append("idProceso", item.idProceso);
      swal({
        title: "Este proceso sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .post(`${env.endpoint}user/denegarAprobacion`, aceptar, {})
            .then((res) => {
              swal("Se ha enviado con exito!", {
                icon: "success",
              });
              this.refrescarApps();
              this.close1();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.editarinventario = res.data;
              this.refrescarApps();
              this.close1();
            });
        } else {
          swal("Proceso de enviado sea cancelado");
          this.close1();
        }
      });
    },

    eliminarCompra(item) {
      const procesoId = item.idProceso ?? item.idProceso_procesos;

      if (!procesoId) {
        console.error("❌ No se pudo determinar idProceso", item);
        return;
      }

      swal({
        title: "¿Estás seguro?",
        text: "El proceso desaparecerá de la vista pero se conservará en la base de datos.",
        icon: "warning",
        buttons: ["Cancelar", "Eliminar"],
        dangerMode: true,
      }).then((willDelete) => {
        if (!willDelete) return;

        // 🔥 Usar axios con la misma estructura que obtenerApps
        axios
          .post(`${env.endpoint}user/eliminarProceso`, {
            idProceso: procesoId,
          })
          .then((res) => {
            if (res.data.success) {
              // ✅ Eliminar del caché
              this.cacheProcesos = this.cacheProcesos.filter(
                (p) =>
                  p.idProceso !== procesoId &&
                  p.idProceso_procesos !== procesoId,
              );

              // ✅ Eliminar de procesosOriginales
              this.procesosOriginales = this.procesosOriginales.filter(
                (p) =>
                  p.idProceso !== procesoId &&
                  p.idProceso_procesos !== procesoId,
              );

              // ✅ Actualizar timestamp del caché
              this.cacheTimestamp = Date.now();

              // ✅ Agregar a lista de eliminados
              this.procesosEliminados.push(procesoId);

              // ✅ Reaplicar filtros
              this.aplicarFiltrosPorDefecto();

              swal("Proceso eliminado correctamente", { icon: "success" });
            } else {
              swal(
                "Error al eliminar",
                res.data.message || "Intenta de nuevo",
                "error",
              );
            }
          })
          .catch((error) => {
            console.error("❌ Error en la petición:", error);
            swal(
              "Error de conexión",
              "No se pudo eliminar el proceso",
              "error",
            );
          });
      });
    },

    modalPdf(item) {
      // ✅ Validar que item existe
      if (!item) {
        console.error("Item es undefined");
        return;
      }

      // ✅ Validar que los proveedores existen antes de acceder
      const proveedor1Valido =
        item.proveedor1 &&
        (item.proveedor1.nombreEmpresa ||
          Object.keys(item.proveedor1).length > 0);

      const proveedor2Valido =
        item.proveedor2 &&
        (item.proveedor2.nombreEmpresa ||
          Object.keys(item.proveedor2).length > 0);

      const proveedor3Valido =
        item.proveedor3 &&
        (item.proveedor3.nombreEmpresa ||
          Object.keys(item.proveedor3).length > 0);

      if (!proveedor1Valido && !proveedor2Valido && !proveedor3Valido) {
        swal({
          title: "No puedes visualizar",
          text: "No hay proveedores registrados para este proceso",
          icon: "warning",
          button: "Cerrar",
        });
        return;
      }

      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // ✅ Asegurar que los proveedores tengan estructura de array para valores
      if (this.editedItem.proveedor1 && !this.editedItem.proveedor1.valores) {
        this.editedItem.proveedor1.valores = [];
      }
      if (this.editedItem.proveedor2 && !this.editedItem.proveedor2.valores) {
        this.editedItem.proveedor2.valores = [];
      }
      if (this.editedItem.proveedor3 && !this.editedItem.proveedor3.valores) {
        this.editedItem.proveedor3.valores = [];
      }

      // ✅ SOLUCIÓN: Asegurar que todos los proveedores tengan la misma cantidad de valores que infoProceso
      const numItems = this.editedItem.infoProceso?.length || 0;

      if (this.editedItem.proveedor1 && numItems > 0) {
        while ((this.editedItem.proveedor1.valores?.length || 0) < numItems) {
          if (!this.editedItem.proveedor1.valores) {
            this.editedItem.proveedor1.valores = [];
          }
          this.editedItem.proveedor1.valores.push({
            idDescripcion: this.editedItem.proveedor1.valores.length + 1,
            valorUnitario: 0,
            iva: 0,
            subtotal: 0,
            valorTotal: 0,
          });
        }
      }

      if (this.editedItem.proveedor2 && numItems > 0) {
        while ((this.editedItem.proveedor2.valores?.length || 0) < numItems) {
          if (!this.editedItem.proveedor2.valores) {
            this.editedItem.proveedor2.valores = [];
          }
          this.editedItem.proveedor2.valores.push({
            idDescripcion: this.editedItem.proveedor2.valores.length + 1,
            valorUnitario: 0,
            iva: 0,
            subtotal: 0,
            valorTotal: 0,
          });
        }
      }

      if (this.editedItem.proveedor3 && numItems > 0) {
        while ((this.editedItem.proveedor3.valores?.length || 0) < numItems) {
          if (!this.editedItem.proveedor3.valores) {
            this.editedItem.proveedor3.valores = [];
          }
          this.editedItem.proveedor3.valores.push({
            idDescripcion: this.editedItem.proveedor3.valores.length + 1,
            valorUnitario: 0,
            iva: 0,
            subtotal: 0,
            valorTotal: 0,
          });
        }
      }

      this.dialog = true;
    },

    downloadExcel() {
      const reportes = [];
      try {
        // Usar procesosOriginales para exportar todos los registros, no solo los filtrados
        if (!this.procesosOriginales || !this.procesosOriginales.length) {
          swal({
            title: "Sin datos",
            text: "No hay procesos para exportar.",
            icon: "info",
            button: "Cerrar",
          });
          return;
        }

        // ✅ Procesar todos los datos en una sola iteración optimizada
        this.procesosOriginales.forEach((proceso) => {
          // ✅ Pre-calcular arrays para evitar múltiples iteraciones
          const infoProceso = proceso.infoProceso || [];
          const cantidades = infoProceso
            .map((e) => e.cantidad)
            .filter((c) => c);
          const conceptos = infoProceso.map((e) => e.concepto).filter((c) => c);
          const especificaciones = infoProceso
            .map((e) => e.expecificaciones)
            .filter((e) => e);
          const observaciones = infoProceso
            .map((e) => e.observaciones)
            .filter((o) => o);

          const item = {
            ID: proceso.idProceso,
            Nombre_Director: proceso.nombre,
            Empresa:
              infoProceso.find((e) => e.empresa)?.empresa || "No asignada",
            Fecha_creacion: proceso.fechaCreacion,
            Cantidad: cantidades.join(" - "),
            Concepto: conceptos.join(" - "),
            Detalle_técnico: especificaciones.join(" - "),
            Argumento_para_la_compra: observaciones.join(" - "),
            Estado: this.getEstadoLabel(proceso.estado),
            Observaciones: proceso.observacion || "",
            Proveedor1_NombreEmpresa: proceso.proveedor1?.nombreEmpresa || "",
            Proveedor1_SubTotal: proceso.proveedor1?.subTotal || "",
            Proveedor2_NombreEmpresa: proceso.proveedor2?.nombreEmpresa || "",
            Proveedor2_SubTotal: proceso.proveedor2?.subTotal || "",
            Proveedor3_NombreEmpresa: proceso.proveedor3?.nombreEmpresa || "",
            Proveedor3_SubTotal: proceso.proveedor3?.subTotal || "",
            Fecha_Entrega: proceso.fechaEntrega || "",
          };
          reportes.push(item);
        });

        // Crear hoja desde JSON
        const ws = XLSX.utils.json_to_sheet(reportes, { skipHeader: false });

        // Ajuste básico de anchos por columna
        const headers = Object.keys(reportes[0] || {});
        const colWidths = headers.map((h) => {
          const maxLen = reportes.reduce((acc, row) => {
            const v = row[h] == null ? "" : String(row[h]);
            return Math.max(acc, v.length);
          }, h.length);
          const extra =
            5 + (reportes.some((r) => String(r[h]).includes("\n")) ? 15 : 0);
          return { wch: Math.min(Math.max(maxLen + extra, 12), 60) };
        });
        ws["!cols"] = colWidths;

        // Crear libro y anexar hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Todos los procesos");

        // Nombre de archivo con fecha
        const hoy = new Date();
        const yyyy = hoy.getFullYear();
        const mm = String(hoy.getMonth() + 1).padStart(2, "0");
        const dd = String(hoy.getDate()).padStart(2, "0");
        const fileName = `todos_procesos_${yyyy}-${mm}-${dd}.xlsx`;

        // Escribir archivo
        XLSX.writeFile(wb, fileName);
      } catch (e) {
        console.error(e);
        swal({
          title: "Error",
          text: "No se pudo exportar a Excel. Intente nuevamente.",
          icon: "error",
          button: "Cerrar",
        });
      }
    },

    getEstadoLabel(estado) {
      // ✅ Usar computed cache para mejor rendimiento
      return this.estadosCache[estado] || "Desconocido";
    },

    // Método para inicializar proveedores con estructura correcta
    inicializarProveedores() {
      const proveedores = ["proveedor1", "proveedor2", "proveedor3"];

      proveedores.forEach((proveedorKey) => {
        if (!this.procesoEditado[proveedorKey]) {
          this.procesoEditado[proveedorKey] = {
            nombreEmpresa: "",
            subTotal: 0,
            iva: 0,
            total: 0,
            valores: [],
          };
        }

        // Asegurar que tenga la estructura de valores correcta
        if (!this.procesoEditado[proveedorKey].valores) {
          this.procesoEditado[proveedorKey].valores = [];
        }

        // Inicializar valores para cada producto si no existen
        if (this.procesoEditado.infoProceso) {
          this.procesoEditado.infoProceso.forEach((producto, index) => {
            if (!this.procesoEditado[proveedorKey].valores[index]) {
              this.procesoEditado[proveedorKey].valores[index] = {
                idDescripcion: producto.id || index + 1,
                subtotal: 0,
                valorTotal: 0,
                iva: 0,
                valorUnitario: 0,
              };
            }
          });
        }
      });

      // Calcular subtotales iniciales
      this.calcularSubtotalTotalProveedor1();
      this.calcularSubtotalTotalProveedor2();
      this.calcularSubtotalTotalProveedor3();
    },

    abrirDialogDescarga(item) {
      console.log("📦 Item recibido:", item);
      console.log("📋 infoProceso:", item.infoProceso);

      this.itemDescarga = item;
      this.mostrarEdicionCantidad = false;

      // Buscar proveedor guardado
      const proveedorGuardado =
        this.proveedorSeleccionadoPorProceso[item.idProceso] ||
        item.proveedorSeleccionado ||
        (item.proveedor1 && item.proveedor1.oc ? 1 : null) ||
        (item.proveedor2 && item.proveedor2.oc ? 2 : null) ||
        (item.proveedor3 && item.proveedor3.oc ? 3 : null);

      // ✅ SIEMPRE cargar conceptos desde infoProceso PRIMERO (valor por defecto)
      if (
        item.infoProceso &&
        Array.isArray(item.infoProceso) &&
        item.infoProceso.length > 0
      ) {
        // Cargar todos los artículos válidos en infoProceso
        this.conceptosEditados = item.infoProceso
          .filter((a) => a) // eliminar entradas falsas
          .map((a) => ({
            concepto: a.concepto || "",
            cantidad: a.cantidad || 0,
          }));
        console.log(
          "✅ Conceptos cargados desde infoProceso (todos):",
          this.conceptosEditados,
        );
      } else {
        this.conceptosEditados = [];
        console.warn("⚠️ No hay infoProceso disponible");
      }

      // Prellenar campos si hay proveedor guardado
      if (proveedorGuardado) {
        try {
          const provKey =
            Number(proveedorGuardado) === 1
              ? "proveedor1"
              : Number(proveedorGuardado) === 2
              ? "proveedor2"
              : "proveedor3";
          const provData = item && item[provKey] ? item[provKey] : null;

          // Prellenar O.C
          this.ocNumero = provData && provData.oc ? provData.oc : "";

          // ✅ SOBRESCRIBIR conceptos SI hay guardados previamente (normalizarlos)
          if (
            provData &&
            provData.conceptosEditados &&
            Array.isArray(provData.conceptosEditados) &&
            provData.conceptosEditados.length > 0
          ) {
            this.conceptosEditados = provData.conceptosEditados.map((c) => ({
              concepto: c && c.concepto ? c.concepto : "",
              cantidad: c && c.cantidad ? c.cantidad : 0,
            }));
            console.log(
              "✅ Conceptos sobrescritos desde proveedor guardado:",
              this.conceptosEditados,
            );
          }

          // Prellenar fecha de entrega
          if (
            provData &&
            provData.fechaEntrega &&
            provData.fechaEntrega !== "0000-00-00"
          ) {
            this.fechaEntregaDescarga = provData.fechaEntrega;
          } else if (item.fechaEntrega && item.fechaEntrega !== "0000-00-00") {
            this.fechaEntregaDescarga = item.fechaEntrega;
          } else {
            this.fechaEntregaDescarga = "";
          }

          // Prellenar fecha general
          if (
            provData &&
            provData.fechaGeneral &&
            provData.fechaGeneral !== "0000-00-00"
          ) {
            this.fechaGeneral = provData.fechaGeneral;
            this.fechaGeneralMostrar = provData.fechaGeneral;
          } else {
            this.fechaGeneral = "";
            this.fechaGeneralMostrar = "";
          }

          this.proveedorSeleccionado = Number(proveedorGuardado);
        } catch (e) {
          console.error("Error al prellenar datos:", e);
          this.ocNumero = "";
          this.fechaEntregaDescarga = "";
          this.fechaGeneral = "";
          this.fechaGeneralMostrar = "";
          this.proveedorSeleccionado = null;
          // Los conceptos ya fueron cargados antes, no los tocamos aquí
        }
      } else {
        // Sin proveedor guardado - inicializar campos vacíos
        this.proveedorSeleccionado = null;
        this.fechaEntregaDescarga =
          item.fechaEntrega && item.fechaEntrega !== "0000-00-00"
            ? item.fechaEntrega
            : "";
        this.fechaGeneral = "";
        this.fechaGeneralMostrar = "";
        this.ocNumero = "";
        // Los conceptos ya fueron cargados antes desde infoProceso
      }

      // Abrir modal
      this.dialogDescargaKey++;
      this.dialogDescarga = true;

      this.$nextTick(() => {
        if (this.proveedorSeleccionado) {
          this.$forceUpdate();
        }
      });
    },
    actualizarCamposPorProveedor() {
      // Actualizar campos cuando se cambia el proveedor seleccionado
      if (!this.itemDescarga || !this.proveedorSeleccionado) return;

      const provKey =
        Number(this.proveedorSeleccionado) === 1
          ? "proveedor1"
          : Number(this.proveedorSeleccionado) === 2
          ? "proveedor2"
          : "proveedor3";
      const provData = this.itemDescarga[provKey] || {};

      // Actualizar O.C
      this.ocNumero = provData.oc || "";

      // Actualizar concepto: priorizar array guardado en el proveedor, luego usar el primer artículo original
      if (
        provData &&
        Array.isArray(provData.conceptosEditados) &&
        provData.conceptosEditados.length > 0
      ) {
        this.conceptosEditados = provData.conceptosEditados.map((c) => ({
          concepto: c && c.concepto ? c.concepto : "",
          cantidad: c && c.cantidad ? c.cantidad : 0,
        }));
      } else if (
        this.itemDescarga &&
        Array.isArray(this.itemDescarga.infoProceso) &&
        this.itemDescarga.infoProceso.length > 0
      ) {
        // Cargar todos los artículos originales
        this.conceptosEditados = this.itemDescarga.infoProceso
          .filter((a) => a)
          .map((a) => ({
            concepto: a.concepto || "",
            cantidad: a.cantidad || 0,
          }));
      } else {
        this.conceptosEditados = [];
      }

      // Actualizar fecha de entrega
      if (provData.fechaEntrega && provData.fechaEntrega !== "0000-00-00") {
        this.fechaEntregaDescarga = provData.fechaEntrega;
      } else if (
        this.itemDescarga.fechaEntrega &&
        this.itemDescarga.fechaEntrega !== "0000-00-00"
      ) {
        this.fechaEntregaDescarga = this.itemDescarga.fechaEntrega;
      } else {
        this.fechaEntregaDescarga = "";
      }

      // Actualizar fecha general
      if (provData.fechaGeneral && provData.fechaGeneral !== "0000-00-00") {
        this.fechaGeneral = provData.fechaGeneral;
        this.fechaGeneralMostrar = provData.fechaGeneral;
      } else {
        this.fechaGeneral = "";
        this.fechaGeneralMostrar = "";
      }
    },
    cerrarDialogDescarga() {
      this.dialogDescarga = false;
      this.mostrarEdicionCantidad = false;
      this.itemDescarga = null;
      this.proveedorSeleccionado = null;
      this.fechaEntregaDescarga = "";
      this.fechaGeneral = ""; // Limpiar fecha general
      this.fechaGeneralMostrar = ""; // Limpiar fecha general mostrar
      this.ocNumero = "";
      this.conceptosEditados = []; // Limpiar concepto
      this.menuFechaDescarga = false; // Cerrar el menú de fecha
      this.menuFechaGeneral = false; // Cerrar el menú de fecha general
      this.dialogDescargaKey++;
    },
    async descargarPDFSeleccionado() {
      // ✅ VALIDACIÓN: Verificar que todos los campos estén completos
      if (
        !this.itemDescarga ||
        !this.proveedorSeleccionado ||
        !this.fechaEntregaDescarga ||
        !this.ocNumero ||
        !this.conceptosEditados || // ← Cambio: verificar array
        this.conceptosEditados.length === 0 || // ← Nuevo: verificar que no esté vacío
        !this.fechaGeneral
      ) {
        alert(
          "Debes completar todos los campos: proveedor, O.C #, Fecha General, conceptos de artículos y fecha de entrega.",
        );
        return;
      }

      // ✅ VALIDACIÓN ADICIONAL: Verificar que todos los conceptos tengan texto
      const conceptosVacios = this.conceptosEditados.filter(
        (art) => !art.concepto || art.concepto.trim() === "",
      );
      if (conceptosVacios.length > 0) {
        alert(
          `Hay ${conceptosVacios.length} artículo(s) sin concepto. Por favor completa todos los campos.`,
        );
        return;
      }

      // ✅ VALIDACIÓN DE CANTIDAD: vacía, 0, negativa o no numérica
      const cantidadesInvalidas = this.conceptosEditados.filter((art) => {
        const cant = Number(art.cantidad);
        return (
          art.cantidad === null ||
          art.cantidad === undefined ||
          art.cantidad === "" ||
          isNaN(cant) ||
          cant <= 0
        );
      });
      if (cantidadesInvalidas.length > 0) {
        alert(
          `Hay ${cantidadesInvalidas.length} artículo(s) con cantidad inválida.\nLa cantidad debe ser un número mayor a 0.`,
        );
        return;
      }

      // Guardar la selección de proveedor para este proceso
      this.$set(
        this.proveedorSeleccionadoPorProceso,
        this.itemDescarga.idProceso,
        this.proveedorSeleccionado,
      );

      // Asegurarse de que el idChecklist exista y sea correcto
      let idChecklist =
        this.itemDescarga.idChecklist ||
        this.itemDescarga.id_checklist ||
        this.itemDescarga.idProceso_procesos ||
        this.itemDescarga.id ||
        null;
      if (!idChecklist) {
        alert(
          "No se encontró el ID del checklist para este proceso. Claves disponibles: " +
            Object.keys(this.itemDescarga).join(", "),
        );
        this.$emit(
          "showSnackbar",
          "No se encontró el ID del checklist para este proceso.",
        );
        return;
      }

      // Guardar la fecha seleccionada en la variable principal de fechaEntrega
      this.fechaEntrega = this.fechaEntregaDescarga;

      // ✅ Guardar conceptos actualizados en la base de datos
      if (this.itemDescarga && this.itemDescarga.idProceso) {
        const idx = this.procesos.findIndex(
          (p) => p.idProceso === this.itemDescarga.idProceso,
        );
        if (idx !== -1) {
          // ✅ CAMBIO: Actualizar TODOS los conceptos en infoProceso, no solo el primero
          if (
            this.procesos[idx].infoProceso &&
            this.procesos[idx].infoProceso.length > 0
          ) {
            // Actualizar cada artículo con su concepto y cantidad editados
            this.conceptosEditados.forEach((articuloEditado, i) => {
              if (this.procesos[idx].infoProceso[i]) {
                this.$set(
                  this.procesos[idx].infoProceso[i],
                  "concepto",
                  articuloEditado.concepto,
                );
                this.$set(
                  this.procesos[idx].infoProceso[i],
                  "cantidad",
                  articuloEditado.cantidad,
                );
              }
            });
          }

          this.$set(
            this.procesos[idx],
            "fechaEntrega",
            this.fechaEntregaDescarga,
          );
          this.$set(
            this.procesos[idx],
            "proveedorSeleccionado",
            this.proveedorSeleccionado,
          );

          try {
            console.log(
              "📤 Enviando conceptosEditados:",
              this.conceptosEditados,
            );
            // ✅ CAMBIO: Enviar el array completo de conceptos
            const response = await axios.post(
              `${env.endpoint}user/actualizarProveedorSeleccionado`,
              {
                idProceso: this.itemDescarga.idProceso,
                proveedorSeleccionado: Number(this.proveedorSeleccionado),
                fechaEntrega: this.fechaEntregaDescarga,
                oc: this.ocNumero,
                conceptosEditados: this.conceptosEditados, // ← Array completo en lugar de string
                fechaGeneral: this.fechaGeneral,
              },
            );

            // ✅ Persistir O.C, conceptos y fecha general en el JSON local del proveedor seleccionado
            const provKey =
              Number(this.proveedorSeleccionado) === 1
                ? "proveedor1"
                : Number(this.proveedorSeleccionado) === 2
                ? "proveedor2"
                : "proveedor3";
            const provLocal = this.procesos[idx][provKey] || {};
            provLocal.oc = this.ocNumero;
            provLocal.fechaEntrega = this.fechaEntregaDescarga;
            provLocal.conceptosEditados = JSON.parse(
              JSON.stringify(this.conceptosEditados),
            ); // ← Guardar array
            provLocal.fechaGeneral = this.fechaGeneral;
            this.$set(this.procesos[idx], provKey, provLocal);
          } catch (error) {
            console.error("Error al actualizar proveedorSeleccionado:", error);
            swal({
              title: "Error",
              text: "No se pudo guardar los conceptos. Inténtalo de nuevo.",
              icon: "error",
              button: "Cerrar",
            });
            return;
          }
        }
      }

      // Preparar datos para la descarga
      const proveedorParaDescarga =
        this.proveedorSeleccionadoPorProceso[this.itemDescarga.idProceso];
      const fechaParaDescarga =
        this.fechaEntregaDescarga ||
        (
          this.procesos.find(
            (p) => p.idProceso === this.itemDescarga.idProceso,
          ) || {}
        ).fechaEntrega ||
        null;

      // Normalizar fechaGeneral antes de enviar (asegurar formato YYYY-MM-DD)
      if (this.fechaGeneralMostrar && !this.fechaGeneral) {
        this.normalizarFechaGeneral();
      }

      // Cerrar el dialog y limpiar selección después de disparar la descarga
      this.dialogDescarga = false;

      // Abrir la descarga de forma asíncrona para evitar bloqueos
      setTimeout(() => {
        // ✅ CAMBIO: Enviar array de conceptos al método de descarga
        this.descargarChecklistPDF(
          idChecklist,
          proveedorParaDescarga,
          fechaParaDescarga,
          this.ocNumero,
          this.conceptosEditados, // ← Array completo en lugar de string
          this.fechaGeneral,
        );

        // Limpiar campos locales
        this.proveedorSeleccionado = null;
        this.fechaEntregaDescarga = "";
        this.fechaGeneral = "";
        this.fechaGeneralMostrar = "";
        this.ocNumero = "";
        this.conceptosEditados = []; // ← Limpiar array
      }, 300);
    },
    realizarCompraDesdeModal() {
      if (this.itemDescarga && this.fechaEntregaDescarga) {
        // Guardar una copia del item ANTES de cerrar el modal
        const itemParaCompra = { ...this.itemDescarga };

        // Asignar la fecha del modal a la variable que usa realizarCompra
        this.fechaEntrega = this.fechaEntregaDescarga;

        // Cerrar el modal de descarga primero
        this.cerrarDialogDescarga();

        // Usar la copia guardada del item
        this.realizarCompra(itemParaCompra);
      }
    },
    // Método para aplicar estilos personalizados a los campos de fecha
    aplicarEstilosFechaEntrega() {
      // Esperar un poco más para asegurar que la tabla esté completamente renderizada
      setTimeout(() => {
        const fechaFields = document.querySelectorAll(".fecha-entrega-field");
        fechaFields.forEach((field) => {
          const slot = field.querySelector(".v-input__slot");
          const input = field.querySelector("input");
          const prependIcon = field.querySelector(".v-input__prepend-inner");

          // Obtener el estado del proceso para aplicar colores diferentes
          const row = field.closest("tr");
          const estadoCell = row ? row.querySelector("[data-estado]") : null;
          const estado = estadoCell
            ? estadoCell.getAttribute("data-estado")
            : null;

          // Solo bordes coloridos según el estado - Azul claro por defecto
          let backgroundColor = "white"; // Fondo blanco por defecto
          let borderColor = "#ADD8E6"; // Azul claro por defecto
          let shadowColor = "rgba(173, 216, 230, 0.1)";

          if (estado === "3") {
            // COMPRAS
            borderColor = "#ADD8E6";
            shadowColor = "rgba(173, 216, 230, 0.1)";
          } else if (estado === "5") {
            // DIRECCION FINANCIERA
            borderColor = "#ADD8E6";
            shadowColor = "rgba(173, 216, 230, 0.1)";
          } else if (estado === "2") {
            // RECHAZADO
            borderColor = "#ADD8E6";
            shadowColor = "rgba(173, 216, 230, 0.1)";
          } else if (estado === "8") {
            // COMPRA REALIZADA
            borderColor = "#ADD8E6";
            shadowColor = "rgba(173, 216, 230, 0.1)";
          }

          if (slot) {
            slot.style.background = "transparent";
            slot.style.border = "none";
            slot.style.borderBottom = "1px solid #ccc";
            slot.style.borderRadius = "0";
            slot.style.boxShadow = "none";
            slot.style.padding = "0 0 4px 0";
            slot.style.minHeight = "32px";
            slot.style.margin = "0";
            slot.style.transition = "all 0.3s ease";
          }

          if (input) {
            input.style.color = "#333";
            input.style.fontWeight = "600";
          }

          if (prependIcon) {
            prependIcon.style.color = "#666";
            prependIcon.style.marginRight = "8px";
          }
        });
      }, 1000);
    },

    // Método para abrir el selector de fecha (similar al botón REALIZAR COMPRA)
    abrirSelectorFecha(item) {
      // Forzar la apertura del menú
      this.$set(item, "menuFecha", true);

      // Asegurar que el menú se abra después de un pequeño delay
      this.$nextTick(() => {
        item.menuFecha = true;

        // Verificar si el menú se abrió correctamente
        setTimeout(() => {
          if (!item.menuFecha) {
            this.$forceUpdate();
          }
        }, 100);
      });
    },

    // Método para actualizar la fecha de entrega directamente en la tabla
    async actualizarFechaEntrega(item) {
      // Cerrar el menú después de seleccionar la fecha
      item.menuFecha = false;

      try {
        const procesoId = item.idProceso || item.idProceso_procesos;
        const fechaNueva = item.fechaEntregaFormatted;

        // Validar que haya una fecha
        if (!fechaNueva) {
          swal({
            title: "Fecha vacía",
            text: "Por favor selecciona una fecha válida",
            icon: "warning",
            button: "Cerrar",
          });
          return;
        }

        // Validar que haya un ID de proceso
        if (!procesoId) {
          swal({
            title: "Error",
            text: "No se pudo identificar el proceso. Recarga la página e intenta de nuevo.",
            icon: "error",
            button: "Cerrar",
          });
          return;
        }

        // Intentar actualizar en el backend
        let response;
        try {
          response = await axios.post(
            `${env.endpoint}user/actualizarFechaEntrega`,
            {
              idProceso: procesoId,
              fechaEntrega: fechaNueva,
            },
          );
        } catch (endpointError) {
          // Intentar con endpoint alternativo
          try {
            response = await axios.post(
              `${env.endpoint}user/updateFechaEntrega`,
              {
                idProceso: procesoId,
                fechaEntrega: fechaNueva,
              },
            );
          } catch (altError) {
            // Intentar con método PUT
            response = await axios.put(
              `${env.endpoint}user/actualizarFechaEntrega/${procesoId}`,
              {
                fechaEntrega: fechaNueva,
              },
            );
          }
        }

        // Verificar diferentes formatos de respuesta del servidor
        if (
          response.data &&
          (response.data.estado ||
            response.data.success ||
            response.data === true)
        ) {
          // Actualización optimista: mantener ambos campos actualizados
          item.fechaEntrega = fechaNueva;
          item.fechaEntregaFormatted = fechaNueva;

          // Forzar la reactividad de Vue para actualizar la vista inmediatamente
          this.$forceUpdate();

          // Actualización exitosa
          // Formatear la fecha correctamente sin desfase de zona horaria
          const fechaFormateada = fechaNueva.split("-").reverse().join("/");
          swal({
            title: "¡Fecha actualizada!",
            text: `La fecha de entrega se ha actualizado a ${fechaFormateada}`,
            icon: "success",
            timer: 2000,
            buttons: false,
          });

          // NO refrescar la tabla inmediatamente para evitar revertir el valor
          // La actualización optimista ya refleja el cambio en la UI
        } else {
          console.error("Error en la respuesta:", response.data);
          swal({
            title: "Error",
            text:
              response.data?.mensaje ||
              response.data?.message ||
              "No se pudo actualizar la fecha",
            icon: "error",
            button: "Cerrar",
          });
        }
      } catch (error) {
        console.error("Error al actualizar fecha de entrega:", error);
        swal({
          title: "Error",
          text: "Ocurrió un error al actualizar la fecha. Intente nuevamente.",
          icon: "error",
          button: "Cerrar",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fondo {
  background-color: rgb(207, 206, 206);
}

.displayCenter {
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  padding: 3px 0px 3px 0px;
}

.displayEnd {
  display: flex;
  justify-content: end;
  align-items: end;
  word-break: break-all;
  padding: 10px;
}

.title_h2 {
  text-align: center;
  font-size: 27px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.archivo-preview-modal-director {
  cursor: pointer;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 8px;
}
.archivo-nombre-modal-director {
  font-size: 13px;
  word-break: break-all;
  max-width: 160px;
  text-align: center;
  margin-bottom: 12px;
}

/* Filtros modernos y profesionales */
.filtros-container-moderno {
  background: transparent;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  border: none;
  box-shadow: none;
  backdrop-filter: none;
}

/* Campos de entrada modernos */
.modern-input {
  transition: all 0.3s ease;
}

/* Forzar estilos en campos outlined */
.modern-input.v-text-field--outlined .v-input__control .v-input__slot,
.modern-input .v-input__control .v-input__slot {
  background: transparent !important;
  border: 2px solid #1976d2 !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1) !important;
  transition: all 0.3s ease !important;
}

.modern-input.v-text-field--outlined .v-input__control .v-input__slot:hover,
.modern-input .v-input__control .v-input__slot:hover {
  border-color: #1565c0 !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2) !important;
}

.modern-input.v-text-field--outlined
  .v-input__control
  .v-input__slot.v-input--is-focused,
.modern-input .v-input__control .v-input__slot.v-input--is-focused {
  border-color: #0d47a1 !important;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.3) !important;
}

/* Sobrescribir el color del borde de Vuetify */
.modern-input.v-text-field--outlined .v-input__control .v-input__slot fieldset {
  border-color: #1976d2 !important;
  border-width: 2px !important;
}

.modern-input.v-text-field--outlined
  .v-input__control
  .v-input__slot:hover
  fieldset {
  border-color: #1565c0 !important;
}

.modern-input.v-text-field--outlined
  .v-input__control
  .v-input__slot.v-input--is-focused
  fieldset {
  border-color: #0d47a1 !important;
}

/* Buscador especial */
.search-input .v-input__control .v-input__slot,
.search-input.v-text-field--outlined .v-input__control .v-input__slot {
  background: transparent !important;
}

.search-input.v-text-field--outlined .v-input__control .v-input__slot fieldset {
  border-color: #1976d2 !important;
  border-width: 2px !important;
}

/* Contenedor de controles de filtro */
.filter-controls-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

/* Botón de limpiar moderno */
.modern-clear-btn {
  transition: all 0.3s ease !important;
  min-width: 120px !important;
  height: 36px !important;
  font-weight: 500 !important;
  color: #f44336 !important;
  border-color: #f44336 !important;
}

.modern-clear-btn:hover {
  background-color: #f44336 !important;
  color: #ffffff !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3) !important;
}

/* Chip de registros moderno */
.modern-registros-chip {
  min-width: 120px !important;
  height: 36px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2) !important;
}

/* Botón de Excel moderno */
.modern-excel-btn {
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

.modern-excel-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}
</style>
<style>
/* Sin sombra en la tarjeta del modal de descarga PDF (solo en este componente) */
.descarga-pdf-card {
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
}

/* Estilos para campos de fecha en la tabla */
.v-data-table .fecha-entrega-field >>> .v-input__slot {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid #ccc !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 0 4px 0 !important;
  min-height: 32px !important;
  margin: 0 !important;
  transition: all 0.3s ease !important;
}

.v-data-table .fecha-entrega-field >>> input {
  color: #333 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
}

.v-data-table .fecha-entrega-field >>> .v-input__prepend-inner {
  color: #666 !important;
  margin-right: 8px !important;
}

.v-data-table
  .fecha-entrega-field
  >>> input::-webkit-calendar-picker-indicator {
  display: none !important;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  .v-data-table .fecha-entrega-field {
    min-width: 100px !important;
    max-width: 120px !important;
  }

  .v-data-table .fecha-entrega-field >>> input {
    font-size: 11px !important;
  }

  .v-data-table .fecha-entrega-field >>> .v-input__slot {
    padding: 0 6px !important;
    min-height: 28px !important;
  }
}

/* Estilos específicos para cabeceras de proveedores */
.proveedor1-header {
  background: linear-gradient(135deg, #601ae4 0%, #0db5ef 100%) !important;
  color: white !important;
  min-height: 80px !important;
}

.proveedor2-header {
  background: linear-gradient(135deg, #601ae4 0%, #0db5ef 100%) !important;
  color: white !important;
  min-height: 80px !important;
}

.proveedor3-header {
  background: linear-gradient(135deg, #601ae4 0%, #0db5ef 100%) !important;
  color: white !important;
  min-height: 80px !important;
}

/* Estilos para subtotales - mismo gradiente que "Editar Proceso" */
.subtotal-card-proveedor1 {
  background: linear-gradient(19deg, #601ae4 0%, #0db5ef 100%) !important;
}

.subtotal-card-proveedor2 {
  background: linear-gradient(19deg, #601ae4 0%, #0db5ef 100%) !important;
}

.subtotal-card-proveedor3 {
  background: linear-gradient(19deg, #601ae4 0%, #0db5ef 100%) !important;
}

/* ===== ESTILOS MODERNOS PARA TODOS PROCESOS ===== */

/* Contenedor principal */
.todos-procesos-container {
  background: #f8fafc;
  min-height: 100vh;
  margin-left: 5px !important;
  margin-right: 0 !important;
  padding: 0;
  margin: 0;
  width: 100% !important;
  max-width: none !important;
}

/* Header Section */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2rem 0;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.icon-container {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 1rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.title-text {
  color: white;
}

.main-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 1.1rem;
  margin: 0.5rem 0 0 0;
  opacity: 0.9;
  font-weight: 400;
}

.export-section {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.modern-excel-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 0.75rem 2rem !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.modern-excel-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.4) !important;
}

/* Filters Section */
.filters-row {
  display: flex;
  gap: 1rem;
  align-items: end;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.filter-date-left {
  flex: 0 0 180px;
}

.filter-search-center {
  flex: 0 0 250px;
}

.filter-date-right {
  flex: 0 0 180px;
}

.modern-date-field,
.modern-search-field {
  transition: all 0.3s ease;
}

.modern-date-field >>> .v-input__control,
.modern-search-field >>> .v-input__control {
  background: #f8fafc !important;
  border-radius: 12px !important;
  border: 2px solid #e2e8f0 !important;
  transition: all 0.3s ease !important;
}

.modern-date-field >>> .v-input__control:hover,
.modern-search-field >>> .v-input__control:hover {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.modern-date-field >>> .v-input__control:focus-within,
.modern-search-field >>> .v-input__control:focus-within {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

/* Table Section */
.table-section {
  padding: 0 2rem 2rem 2rem;
  background: white;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.modern-table {
  background: transparent !important;
  width: 100% !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-data-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
  overflow-x: scroll !important; /* Scroll horizontal siempre visible */
  overflow-y: visible !important;
  box-shadow: none !important;
  border: none !important;
  width: 100% !important;
  max-width: 100% !important;
  scrollbar-width: thin; /* Para Firefox */
  scrollbar-color: #64748b #e5e7eb; /* Para Firefox */
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important;
  display: block !important;
  -webkit-appearance: none;
}

.modern-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important;
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important;
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important;
}

.modern-data-table >>> .v-data-table {
  width: 100% !important;
  max-width: none !important;
}

.modern-data-table >>> table {
  width: 100% !important;
  max-width: none !important;
}

/* Estilos duplicados eliminados - ya están definidos arriba */

.modern-data-table >>> .v-data-table-header {
  background: #f5f5f5 !important;
  color: #333 !important;
}

.modern-data-table >>> .v-data-table-header th {
  background: #f5f5f5 !important;
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 1rem 0.75rem !important;
}

.modern-data-table >>> .v-data-table-header th.v-data-table-header__icon {
  color: #333 !important;
}

/* Estilos adicionales para forzar el fondo gris claro en el header */
.modern-data-table >>> thead tr {
  background: #f5f5f5 !important;
}

.modern-data-table >>> thead tr th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

.modern-data-table >>> .v-data-table__wrapper thead tr {
  background: #f5f5f5 !important;
}

.modern-data-table >>> .v-data-table__wrapper thead tr th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

/* Estilos más específicos para forzar el cambio */
.modern-data-table >>> .v-data-table__wrapper table thead tr {
  background: #f5f5f5 !important;
}

.modern-data-table >>> .v-data-table__wrapper table thead tr th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

/* Estilos globales para el header */
.v-data-table thead tr {
  background: #f5f5f5 !important;
}

.v-data-table thead tr th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

/* Estilos ultra específicos para forzar el cambio */
.modern-data-table >>> .v-data-table__wrapper table thead tr td,
.modern-data-table >>> .v-data-table__wrapper table thead tr th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

/* Estilos con mayor especificidad */
.todos-procesos-container
  .modern-data-table
  >>> .v-data-table__wrapper
  table
  thead
  tr {
  background: #f5f5f5 !important;
}

.todos-procesos-container
  .modern-data-table
  >>> .v-data-table__wrapper
  table
  thead
  tr
  th {
  background: #f5f5f5 !important;
  color: #333 !important;
}

.modern-data-table >>> .v-data-table tbody tr {
  transition: all 0.3s ease !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.modern-data-table >>> .v-data-table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-data-table >>> .v-data-table tbody td {
  padding: 1rem 0.75rem !important;
  font-size: 0.9rem !important;
  color: #374151 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .filters-row {
    flex-direction: column;
    gap: 1rem;
  }

  .filter-date-left,
  .filter-search-center,
  .filter-date-right {
    flex: 1;
    min-width: 100%;
  }

  .main-title {
    font-size: 1.5rem;
  }
}

/* Estilos para proveedor seleccionado - Solo la bolita del radio button */
.descarga-pdf-card
  .proveedor-radio-item.proveedor-seleccionado
  >>> .v-input--selection-controls__input {
  color: #2196f3 !important;
}

.descarga-pdf-card
  .proveedor-radio-item.proveedor-seleccionado
  >>> .v-input--selection-controls__ripple {
  color: #2196f3 !important;
}

/* Color azul solo para la bolita (círculo) del radio button cuando está seleccionado */
.descarga-pdf-card
  .proveedor-radio-item.proveedor-seleccionado
  >>> .v-input--selection-controls__input
  .v-icon {
  color: #2196f3 !important;
}

/* Asegurar que el color se aplique al radio button seleccionado de Vuetify */
.descarga-pdf-card
  .proveedor-radio-item.proveedor-seleccionado
  >>> .v-radio
  >>> .v-input--selection-controls__input
  >>> .v-icon {
  color: #2196f3 !important;
}

.descarga-pdf-card
  .proveedor-radio-item.proveedor-seleccionado
  >>> .v-radio
  >>> .v-input--selection-controls__input
  >>> i {
  color: #2196f3 !important;
}

/* Estilo más específico para el icono del radio button */
.descarga-pdf-card
  .v-radio.proveedor-radio-item.proveedor-seleccionado
  >>> .v-input--selection-controls__input
  >>> .mdi-radiobox-marked {
  color: #2196f3 !important;
}

.descarga-pdf-card
  .v-radio.proveedor-radio-item.proveedor-seleccionado
  >>> .v-input--selection-controls__input
  >>> .mdi-radiobox-blank {
  color: #2196f3 !important;
}

/* Estilos para cuando el radio button está realmente seleccionado (checked) */
.descarga-pdf-card
  .v-radio.proveedor-radio-item
  >>> input[type="radio"]:checked
  ~ .v-input--selection-controls__input
  .v-icon {
  color: #2196f3 !important;
}

.descarga-pdf-card
  .v-radio.proveedor-radio-item.proveedor-seleccionado
  >>> input[type="radio"]:checked
  ~ .v-input--selection-controls__input
  .v-icon {
  color: #2196f3 !important;
}

/* Aplicar color directamente al radio cuando está seleccionado */
.descarga-pdf-card
  .v-radio.proveedor-radio-item.proveedor-seleccionado.v-input--is-selected
  >>> .v-input--selection-controls__input
  .v-icon {
  color: #2196f3 !important;
}
</style>
